import { Component, OnInit, ViewChild, ElementRef, SystemJsNgModuleLoader, HostListener } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";
import moment from 'moment';
import 'moment-timezone';
import { ScheduleCalendarComponent } from "../schedule-calendar/schedule-calendar.component";
import { JobScheduleResponse, MaintenanceScheduleRes } from "src/models/Table";
import { SystemUtils } from "../utils/system.utils";
import { SchedulerUtils} from "../utils/scheduler.utils";

interface timeManagement {
  tphours?: any;
  tpminutes?: any;
  tptype?:any;
  tshours?:any,
  tsminutes?:any,
  tstype?:any,
  OccuranceId?:any;
  estEditHoursSelection?:any;
  estEditMinuteSelection?:any;
}

@Component({
  selector: "app-schedule-tabs",
  templateUrl: "./schedule-tabs.component.html",
  styleUrls: ["./schedule-tabs.component.css"],
})



export class ScheduleTabsComponent implements OnInit {

  timemanage: timeManagement = {
    tphours :'00',
    tpminutes:'00',
    tptype:'AM',
    tshours:'00',
    tsminutes:'00',
    tstype:'AM',
    OccuranceId:'',
    estEditHoursSelection:0,
    estEditMinuteSelection:0

  };
timemanageBackup:timeManagement = {
  tphours :'00',
  tpminutes:'00',
  tptype:'AM'
}
  constructor(
    private _restService: RestService,
    private router: Router,
    private el: ElementRef
  ) { }



  date: any = new Date();
  dn: any = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  mn: any = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  hours: any;
  minutes: any;
  rangestart: any = "";
  rangeend: any = "";
  tday: any = "";
  todayDate: any = "";
  currentDate: any = "";
  prevDate: any = "";
  isLoading: boolean = false;
  isLoadingIcon: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  columns: any = [];
  envList: any = [];
  actualArray: any = [];
  filterArray: any = [];
  searchArray: any = [];
  environment: any = "";
  environmentName: any = "";
  //scaleWidth: any = 0;
  getTimeLineData: any = "";
  allEvnArray: any = [];
  maintenanceGroup: any = [];
  jobNameArray: any = [];
  machineGroup: any = [];
  JobScheduleRes: any = [];
  machineNameArray: any = [];
  getTableView: any = [];
  searchMaintenance: any = [];
  searchjobfilterRes: any = [];
  searchMachinefilter: any = [];

  pageSize: any = 0;
  boxSize: any = 0;
  minValue: any = 0;
  maxValue: any = 0;
  prevValue: any = 0;
  totalJobsCount: number = 0;
  paginationLength: number = 0;
  flagCount: any = 0;

  isStartName: boolean = false;
  isEndName: boolean = false;
  isType: boolean = false;
  isName: boolean = false;
  isPath: boolean = false;
  isStatus: boolean = false;
  isActivity: boolean = false;
  isSeries: boolean = false;
  isRangeStartShown: boolean = false;
  isRangeEndShown: boolean = false;
  israngeDateError: boolean = false;

  isEdited: boolean = false;
  isEditOccShown: boolean = false;
  isReviewDateShown: boolean = false;
  isReviewTimeShown: boolean = false;
  editMachineId: any = "";
  isRecurringSelected: boolean = false;
  startDate: any = "";
  // tphours: any = "00";
  // tpminutes: any = "00";
  // tptype: any = "AM";
  
  estEditHoursSelection: any = 0;
  estEditMinuteSelection: any = 0;
  disableIncreaseHrs: boolean = false;
  disableDecreaseHrs: boolean = false;
  disableIncreaseMins: boolean = false;
  disableDecreaseMins: boolean = false;
  estHours: any;
  estMintues: any;
  estEditHours: any;
  estEditMintues: any;
  machineId: any = "";
  isMachineIdInvalid: boolean = false;
  isSmartMatchChecked: boolean = false;

  isFilterModelShown: boolean = false;
  isMachineExpand: boolean = true;
  isJobExpand: boolean = true;
  isMaintenanceExpand: boolean = true;
  lsValue: boolean = false;
  timezoneInfo: boolean = false;

  machinejobArray: any = [];
  MtnfilterArray: any = [];
  MtnSelectedArray: any = [];
  machinesFilterArray: any = [];
  machinesSelectedArray: any = [];
  machinesSearchArray: any = [];
  jobsFilterArray: any = [];
  jobsSelectedArray: any = [];
  jobsSearchArray: any = [];
  machinestoJob: any = [];

  jStep1: any = [];
  jStep2: any = [];
  mStep1: any = [];
  mStep2: any = [];

  botID: any = "";
  occID: any = "";
  mSingleOccId = "";
  mseriesid = "";
  headerobj: any = "";
  headerobjBackup: any = "";
  stype: any = "";
  sysId: any = "";
  Mtype: any = "";
  MsysId: any = "";
  tableobj: any = [];
  tableobjBackup:any = [];
  occurance: any = [];
  machineobj: any = [];
  editedStartDateArray: any = [];
  MSingleArray: any = [];
  MSingleRes: any = [];
  jobRecurringRes: any = [];
  mtnRecurringRes: any = [];
  occurrenceResult: any = "";
  saveFrequency: any = "";
  scheduleListObj: any = "";
  scheduleListOccId: any = "";
  scheduleTxt: any = "";
  delOccBid: any = "";
  delOccMid: any = "";
  searchJobsInput: any = "";
  searchMachineInput: any = "";

  isEditMtnOccShown: boolean = false;
  isEditJobSeriesShown: boolean = false;
  isSeriesClicked: boolean = false;
  isEditMtnSeriesShown: boolean = false;
  isMachineClicked: boolean = false;
  isJobClicked: boolean = false;
  isEvnClicked: boolean = false;
  masterEnvId: any = "";

  isfilterEnabled: boolean = false;
  filtertype: any = "1";
  limitselection: any = "2";
  autoselectmaintenance: any = "2";

  searchMaintenanceInput = "";

  isCalendarSelected: boolean = true;
  isTimelineSelected: boolean = false;
  isTableSelected: boolean = false;
  isDifferentTimezone: boolean = false;

  timelineToggle = true;

  // Delete

  rowID: any = "";
  SID: any = "";
  infoMessage: any = "";
  isConfirmDeleteOcc: boolean = false;
  isConfirmDeleteSeries: boolean = false;
  isInfoModelShown: boolean = false;
  isConfirmDeleteAllOccurrence: boolean = false;

  options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: false,
    headers: [
      "Start Time",
      "End Time",
      "Type",
      "Machine/Path",
      "Status",
      "Activity ID",
      "Series",
    ],
    showTitle: false,
    useBom: false,
    removeNewLines: true,
    keys: [
      "StartFormatted",
      "EndFormatted",
      "type",
      "BotPath",
      "Status",
      "activity",
      "series",
    ],
  };

  jobScheduleResponse: JobScheduleResponse;
  mScheduleResponse: MaintenanceScheduleRes;

  selectedTimeZone: string = "";
  localTimeZone: string = "";

  mSystemAccessList;

  timeLineDate: Date;

  @ViewChild(ScheduleCalendarComponent, { static: false })
  child: ScheduleCalendarComponent;

  private get scaleWidth() {
    return (window.innerWidth - 239 ) / 26
  }
 

  ngOnInit() {
    console.log("entry");

    this.selectedTimeZone = localStorage.getItem("selectedTimeZone");
    this.localTimeZone = localStorage.getItem("localTimeZone");

    var a = (parseInt(localStorage.getItem("windowWidth")) - 239) / 26;
    //this.scaleWidth = a;
    var uniqueMachine: any = [];
    var uniqueJob: any = [];
    localStorage.setItem("isFilter", "false");
    localStorage.setItem("mids", JSON.stringify([]));
    localStorage.setItem("bids", JSON.stringify([]));
    localStorage.setItem("sids", JSON.stringify([]));

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this.columns = Array(25)
      .fill(0)
      .map((x, i) => i);

    var dt = new Date();
    var d = dt.getDate();
    var m = dt.getMonth() + 1;
    var y = dt.getFullYear();

    this.tday = y + "-" + m + "-" + d;
    this.todayDate = y + "-" + m + "-" + d;
    this.currentDate = y + "-" + m + "-" + d;

    this.checkTimezone();

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.envList = f.EnvList),
          console.log("this.envList --------------------", this.envList),
          (this.environment =
            this.envList.length > 0 ? this.envList[0].id.toString() : ""),
          (this.environmentName =
            this.envList.length > 0 ? this.envList[0].Environment_Name : ""),
          this.envList.filter((m: any) =>
            parseInt(m.id) === parseInt(this.environment)
              ? (this.masterEnvId = m.MasterEnvId)
              : ""
          ),
          (this.isLoading = false),
          console.log("this.environment", this.environment),
          this._restService
            .getLeftPanelData(
              this.environment,
              this.filtertype,
              this.limitselection,
              this.autoselectmaintenance,
              this.masterEnvId
            )
            .pipe(
              catchError((e) => {
                (this.isLoading = false),
                  (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                return e;
              })
            )
            .subscribe(
              (f: any) => (
                (this.MtnfilterArray = f.FilterRes.level2List),
                this.MtnfilterArray.map((f: any) => (f.checked = false)),
                (this.searchMaintenance = this.MtnfilterArray),
                (this.machinejobArray = f.FilterRes.leftPanelMachineBotRes),
                this.machinejobArray.map(
                  (f: any) => ((f.mchecked = false), (f.bchecked = false))
                ),
                (uniqueMachine = this.machinejobArray.reduce(
                  (u: any, o: any) => {
                    if (!u.some((obj: any) => obj.machineId === o.machineId)) {
                      u.push(o);
                    }
                    return u;
                  },
                  []
                )),
                uniqueMachine.map((m: any) =>
                  m.machineId !== null && m.botId !== null
                    ? this.machinesFilterArray.push(m)
                    : ""
                ),
                (uniqueJob = this.machinejobArray.reduce((u: any, o: any) => {
                  if (!u.some((obj: any) => obj.botId === o.botId)) {
                    u.push(o);
                  }
                  return u;
                }, [])),
                uniqueJob.map((m: any) =>
                  m.machineId !== null && m.botId !== null
                    ? this.jobsFilterArray.push(m)
                    : ""
                ),
                console.log('Right here'),
                console.log(uniqueJob),
                console.log(this.jobsFilterArray),
                console.log(uniqueMachine),
                console.log(this.machinesFilterArray),
                (this.machinesSearchArray = this.machinesFilterArray),
                (this.jobsSearchArray = this.jobsFilterArray),
                (this.searchjobfilterRes = this.jobsFilterArray),
                console.log("Machine---->", this.machinesFilterArray),
                console.log("Jobs---->", this.jobsFilterArray)
              )
            ),
            this.callbackTimelineView(this.todayDate)
        )
      );

    var dt = new Date();
    var tdt = new Date();
    tdt.setDate(tdt.getDate() + 30);

    var h = dt.getHours(),
      m = dt.getMinutes();
    var _time = h > 12 ? "PM" : "AM";
    this.hours = h >= 10 ? h : "0" + h;
    this.minutes = m >= 10 ? m : "0" + m;
    this.rangestart = dt;
    this.rangeend = tdt;
    localStorage.setItem(
      "singleDate",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    localStorage.setItem(
      "startRange",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    localStorage.setItem(
      "endRange",
      (
        new Date(tdt).getDate() +
        "/" +
        (new Date(tdt).getMonth() + 1) +
        "/" +
        new Date(tdt).getFullYear()
      ).toString()
    );

    this.estHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estMintues = Array(60)
      .fill(0)
      .map((x, i) => i);

    this.estEditHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estEditMintues = Array(60)
      .fill(0)
      .map((x, i) => i);
  }

  machineGroupEvent() {
    this.isMachineClicked = !this.isMachineClicked;
  }

  jobGroupEvent() {
    this.isJobClicked = !this.isJobClicked;
  }

  environmentGroupEvent() {
    this.isEvnClicked = !this.isEvnClicked;
  }

  callbackTimelineView(specifiedDate?: any) {

    var dt = new Date();

    if (specifiedDate){
      dt = moment(specifiedDate).toDate();
    }else if (this.timeLineDate){
      dt = this.timeLineDate;
    }
    

    this.timeLineDate = dt;



    var d = dt.getDate();
    var m = dt.getMonth() + 1;
    var y = dt.getFullYear();

    this.todayDate = y + "-" + m + "-" + d;

    this._restService
      .getTimeLineView(this.environment, specifiedDate || this.todayDate, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.maintenanceGroup = [];
          this.getTimeLineData = f;

          if (this.getTimeLineData.TimeLineRes.hasOwnProperty("maintenanceGroup")){
            this.getTimeLineData.TimeLineRes.maintenanceGroup.filter(
              (mg: any) => {

                if ( mg.hasOwnProperty("maintenanceList")){
                  mg.maintenanceList.filter(
                    (ml: any) => {
                      ml.start = this.convertToTimeLineStart(new Date(this.timezoneConvert(ml.StartDate)));
                      ml.end =  this.convertToTimeLineEnd(new Date(this.timezoneConvert(ml.EndDate)));
                      ml.StartHours = new Date(ml.start).getHours();
                      ml.StartMinutes = new Date(
                        ml.start
                      ).getMinutes();
                      ml.EndHours = new Date(ml.end).getHours();
                      ml.EndMinutes = new Date(ml.end).getMinutes();
                      ml.position =
                        ml.StartHours * this.scaleWidth +
                        this.scaleWidth / 2 +
                        (ml.StartMinutes / 60) * this.scaleWidth;
                      ml.endPos = ml.EndHours * this.scaleWidth +
                      this.scaleWidth / 2 +
                      (ml.EndMinutes / 60) * this.scaleWidth;
                      ml.length = ml.endPos - ml.position;
                      ml.dropdown = false;

                      return ml.end > ml.start;
                    }
                  )
                }
              });
          }
            
          this.getTimeLineData.TimeLineRes.hasOwnProperty("AllEnv")
            ? ((this.allEvnArray = []),
            this.getTimeLineData.TimeLineRes.maintenanceGroup.forEach(m =>{
              m.maintenanceList.forEach(l => {
                if (!l.systemId){
                  this.allEvnArray.push({
                    MendDate: l.EndDate,
                    MstartDate: l.StartDate,
                    activity_label: l.activity_label,
                    mtn: l
                  });
                }
              });
            }),
            this.getTimeLineData.TimeLineRes.maintenanceGroup = this.getTimeLineData.TimeLineRes.maintenanceGroup.filter(m => {
              return m.maintenanceList.some(l => l.systemId);
            }),
            this.allEvnArray = this.allEvnArray.filter(
                (ae: any) => {
                  ae.start = this.convertToTimeLineStart(new Date(this.timezoneConvert(ae.MstartDate)));
                  ae.end = this.convertToTimeLineEnd( new Date (this.timezoneConvert(ae.MendDate) ));
                  ae.StartHours = new Date(ae.start).getHours();
                  ae.StartMinutes = new Date(ae.start).getMinutes();
                  ae.EndHours = new Date(ae.end).getHours();
                  ae.EndMinutes = new Date(ae.end).getMinutes();
                  ae.position =
                    ae.StartHours * this.scaleWidth +
                    this.scaleWidth / 2 +
                    (ae.StartMinutes / 60) * this.scaleWidth;
                  ae.endPos = ae.EndHours * this.scaleWidth +
                    this.scaleWidth / 2 +
                    (ae.EndMinutes / 60) * this.scaleWidth;
                    ae.length = ae.endPos - ae.position;
                  ae.dropdown = false;
                  
                  return ae.end > ae.start
                }
              ))
            : "",
            console.log(this.allEvnArray),
          console.log("All2", this.getTimeLineData.TimeLineRes),
          this.getTimeLineData.TimeLineRes.hasOwnProperty("machineGroup")
            ? this.getTimeLineData.TimeLineRes.machineGroup.filter((mg2: any) =>
              mg2.hasOwnProperty("scheduleList")
                ? mg2.scheduleList.filter(
                  (ml2: any) => {
                    ml2.start = this.convertToTimeLineStart(new Date ( this.timezoneConvert(ml2.StartDate)));
                    ml2.end =  this.convertToTimeLineEnd(new Date ( this.timezoneConvert(ml2.EndDate)));
                    (ml2.StartHours =
                      ml2.StartDate !== null
                        ? new Date(ml2.start).getHours()
                        : 0);
                    (ml2.StartMinutes =
                      ml2.StartDate !== null
                        ? new Date(ml2.start).getMinutes()
                        : 0);
                    (ml2.EndHours =
                      ml2.EndDate !== null
                        ? new Date(ml2.end).getHours()
                        : 0);
                    (ml2.EndMinutes =
                      ml2.EndDate !== null
                        ? new Date(ml2.end).getMinutes()
                        : 0);
                    (ml2.position =
                      ml2.StartHours * this.scaleWidth +
                      this.scaleWidth / 2 +
                      (ml2.StartMinutes / 60) * this.scaleWidth);
                    ml2.endPos = ml2.EndHours * this.scaleWidth +
                      this.scaleWidth / 2 +
                      (ml2.EndMinutes / 60) * this.scaleWidth;
                      ml2.length = ml2.endPos - ml2.position;
                    (ml2.dropdown = false);

                    return ml2.end > ml2.start;
                  }
                )
                : ""
            )
            : "",
          this.jobScheduleFilter(
            this.getTimeLineData.TimeLineRes.JobScheduleRes
          ),
          (this.maintenanceGroup =
            this.getTimeLineData.TimeLineRes.maintenanceGroup),
          (this.machineGroup = this.getTimeLineData.TimeLineRes.machineGroup),
          this.machineGroup.filter((mg2: any) =>
            mg2.hasOwnProperty("scheduleList")
              ? mg2.scheduleList.filter(
                (f: any) => ((f.hover = false), (f.info = false))
              )
              : ""
          ),
          this.isLoadingIcon = false,
          console.log("Timeline --->", f);

          this.getTimeLineData.TimeLineRes.AllEnv = this.getTimeLineData.TimeLineRes.AllEnv.filter(m => m.end <= m.start);

          this.getTimeLineData.TimeLineRes.machineGroup.forEach(mg => { 
            if (mg.scheduleList){

              mg.scheduleList.forEach(ms => {
                ms.Sstatus = 1;
                this.getTimeLineData.TimeLineRes.maintenanceGroup.forEach(mg1 => { 
                  mg1.maintenanceList.forEach( mg2 =>{
                    if (this.hasConflict(ms, mg2) && (!mg2.systemId || (ms.AccessList && ms.AccessList.indexOf(mg2.systemId) >= 0) ) ){
                      ms.Sstatus = 2;
                    }
                  });
                });

                this.allEvnArray.forEach(mg2 => {
                  if (this.hasConflict(ms, mg2)){
                    ms.Sstatus = 2;
                  }
                });
              });

              const botIds = JSON.parse(localStorage.getItem("bids"));
              mg.scheduleList = mg.scheduleList.filter(m => m.end > m.start && (!botIds.length || botIds.includes(m.BotId)));
            }
          });

          this.getTimeLineData.TimeLineRes.maintenanceGroup.forEach(mg => {
            if (mg.maintenanceList){
              mg.maintenanceList = mg.maintenanceList.filter(m => m.end > m.start);
              mg.maintenanceList.forEach(m => m.Sstatus = 1 );
            }
          });
        });


        console.log(this.getTimeLineData);
  }

  hasConflict(ms: any, mg: any){
    if (mg.end <= mg.start || ms.end <= ms.start){
      return false;
    }else if (ms.start <= mg.start && ms.end > mg.start){
      return true;
    }else if(ms.start < mg.end && ms.end >= mg.end){
      return true;
    }else if (mg.start <= ms.start && mg.end > ms.start){
      return true;
    }else if(mg.start < ms.end && mg.end >= ms.end){
      return true;
    }

    return false;
  }

  gotoTimeline(date: any) {

    this.isLoadingIcon = true;
    this.isCalendarSelected = false;
    this.isTimelineSelected = true;
    this.isTableSelected = false;

    var dt = new Date(date);
    var d = dt.getDate();
    var m = dt.getMonth() + 1;
    var y = dt.getFullYear();

    this.todayDate = y + "-" + m + "-" + d;

    this.callbackTimelineView(this.todayDate);
  }

  editOccurrence(occid: any, bid: any, txt: any) {
    console.log("11111111111111111222222", occid);
    //this.environment
    this.scheduleTxt = txt;
    this.botID = bid;
    this.occID = occid;

    let dt: any = "";
    let ct: any = "";


    if (occid !== undefined) {
      this.isLoadingIcon = true;
      this._restService
        .getJobOccuranceDetail(this.environment, occid, this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("Edit --->", f),
            this.jobScheduleResponse = f,
            f.scheduleListRes === "No occurance found"
              ? ((this.isLoadingIcon = false),
                (this.isEditOccShown = false),
                (this.isInfoModelShown = true),
                (this.infoMessage = "No occurance found"))
              : ((this.isEditOccShown = true), (this.tableobj = [])),
            (this.headerobj = f.scheduleListRes.Header),
            (this.machineobj = f.scheduleListRes.machineList),
            (this.tableobj = f.scheduleListRes.OccuranceTable),
            this.tableobj.filter((m: any) => (m.isfold = false)),
            this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
            this.tableobj.filter(
              (m: any, index: any) => (
                (m.NewStart = this.timezoneConvert(m.NewStart)),
                (m.NewEnd = this.timezoneConvert(m.NewEnd)),
                (m.startDateBefore = (m.scheduleArr[0].startDate)),
                (m.endDateBefore = (m.scheduleArr[0].endDate)),
                console.log("end 12", JSON.stringify(m.scheduleArr))
              ),
            ),
            console.log("table 1", this.tableobj),
            this.tableobj.filter((m: any) =>
              SchedulerUtils.updateScheduleObject(m)
            ),
            console.log("table 2", this.tableobj),
            (this.isLoadingIcon = false)
          )
        );
    }
  }

  chartExpandForMtnEvent(id: any, occid: any) {
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    this.occID = occid;
    var col = this.tableobj;

    col.filter(
      (f: any) => (
        (f.isfold = false),
        parseInt(f.rowid) === parseInt(id)
          ? f.isfold === true
            ? ((f.isfold = false), console.log("in", f.isfold))
            : ((f.isfold = true), console.log("out", f.isfold))
          : ""
      )
    );

    console.log("col", col);
    this.tableobj = col;

    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? ((this.editMachineId = this.isRecurringSelected
          ? f.MachineId
          : f.machineId),
          (this.startDate = f.NewStart),
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ))
        : ""
    );

    // t.filter((f: any) =>
    //   f.rowid === id
    //     ? (new Date(f.NewStart).getHours() > 12
    //         ? new Date(f.NewStart).getHours() - 12 < 10
    //           ? (this.timemanage.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
    //           : (this.timemanage.tphours = new Date(f.NewStart).getHours() - 12)
    //         : new Date(f.NewStart).getHours() < 10
    //         ? (this.timemanage.tphours = "0" + new Date(f.NewStart).getHours())
    //         : new Date(f.NewStart).getHours(),
    //       (this.timemanage.tpminutes =
    //         new Date(f.NewStart).getMinutes().toString().length <= 1
    //           ? "0" + new Date(f.NewStart).getMinutes()
    //           : new Date(f.NewStart).getMinutes()),
    //       (this.timemanage.tptype = new Date(f.NewStart).getHours() > 12 ? "PM" : "AM"))
    //     : ""
    // );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.NewStart).getHours() > 12
          ? (new Date(f.NewStart).getHours() - 12).toString().length > 1
            ? (this.timemanage.tphours = new Date(f.NewStart).getHours() - 12)
            : (this.timemanage.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
          : new Date(f.NewStart).getHours() === 12
            ? (this.timemanage.tphours = new Date(f.NewStart).getHours())
            : new Date(f.NewStart).getHours() < 12
              ? new Date(f.NewStart).getHours().toString().length > 1
                ? (this.timemanage.tphours = new Date(f.NewStart).getHours())
                : (this.timemanage.tphours = "0" + new Date(f.NewStart).getHours())
              : "",
          (this.timemanage.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.timemanage.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.timemanage.tptype = "AM")
              : "")
        : ""
    );

    console.log("duration for Mtn", this.occID);

    let duration: any;

    this.tableobj.filter((f: any) =>
      f.moccuranceid === this.occID ? (duration = f.duration.split(":")) : ""
    );

    this.timemanage.estEditHoursSelection = parseInt(duration[0]);
    this.timemanage.estEditMinuteSelection = parseInt(duration[1]);

    console.log("duration for Mtn", duration);
  }

  refreshScheduleTab() {
    this.child.callScheduleCal();
    this.callbackTimelineView();
  }

  chartExpandEvent(id: any,tbl:any) {
    this.timemanage.estEditHoursSelection = '';
    console.log("id--->" , tbl);
    this.timemanage.OccuranceId = id;

    this.occID = id;
    

    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    var col = this.tableobj;

    // col.filter(
    //   (f: any) => (
    //     (f.isfold = false),
    //     parseInt(f.rowid) === parseInt(id)
    //       ? f.isfold === true
    //         ? ((f.isfold = false), console.log("in", f.isfold))
    //         : ((f.isfold = true), console.log("out", f.isfold))
    //       : ""
    //   )
    // );

    // col.filter((f: any) =>
    //   parseInt(f.rowid) === parseInt(id)
    //     ? f.isfold === false
    //       ? (f.isfold = true)
    //       : (f.isfold = false)
    //     : ""
    // );

    col.filter(
      (f: any) => (
        (f.isfold = false),
        parseInt(f.rowid) === parseInt(id)
          ? f.isfold === true
            ? ((f.isfold = false), console.log("in", f.isfold))
            : ((f.isfold = true), console.log("out", f.isfold))
          : ""
      )
    );

    col.filter((m:any) => (
      // (m.startDate = m.startDate),
      // (m.endDate = m.endDate),
      (console.log("end dates---->" , m))
    ));
    // col.filter((m: any) =>
    
        
    //         (d.startDate = (d.startDate)),
    //          (d.endDate = (d.endDate))

    //     : ""
    //     )
    
  

    console.log("col", col);
    this.tableobj = col;
    this.tableobjBackup = this.tableobj;

    var t = this.tableobj;
    // console.log("hours-->"+this.timemanage.tphours);

    t.filter((f: any) =>
      f.rowid === id
        ? ((this.editMachineId = this.isRecurringSelected
          ? f.MachineId
          : f.machineId),
          (this.startDate = f.NewStart),
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "startDates",
            (
              new Date(f.startDateBefore).getDate() +
              "/" +
              (new Date(f.startDateBefore).getMonth() + 1) +
              "/" +
              new Date(f.startDateBefore).getFullYear()
            ).toString()
          )
          )
        : ""
    );

  t.filter((f: any) =>
  f.rowid === id
    ? (new Date(f.NewStart).getHours() > 12
      ? (new Date(f.NewStart).getHours() - 12).toString().length > 1
        ? (this.timemanage.tphours = new Date(f.NewStart).getHours() - 12)
        : (this.timemanage.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
      : new Date(f.NewStart).getHours() === 12
        ? (this.timemanage.tphours = new Date(f.NewStart).getHours())
        : new Date(f.NewStart).getHours() < 12
          ? new Date(f.NewStart).getHours().toString().length > 1
            ? (this.timemanage.tphours = new Date(f.NewStart).getHours())
            : (this.timemanage.tphours = "0" + new Date(f.NewStart).getHours())
          : "",
      (this.timemanage.tpminutes =
        new Date(f.NewStart).getMinutes().toString().length <= 1
          ? "0" + new Date(f.NewStart).getMinutes()
          : new Date(f.NewStart).getMinutes()),
      new Date(f.NewStart).getHours() >= 12
        ? (this.timemanage.tptype = "PM")
        : new Date(f.NewStart).getHours() < 12
          ? (this.timemanage.tptype = "AM")
          : "")
    : ""
);


    this.tableobj.filter((f: any) =>
      f.OccuranceId === this.occID
        ? (this.headerobj.durations = f.jobDuration)
        : ""
    );

    console.log("this.headerobj", this.headerobj);

    // if(this.headerobj.seriesId){

    //   this.timemanage.estEditHoursSelection = this.headerobj.durations['hours'];
    //   console.log("hours1--->" , Number(this.timemanage.estEditHoursSelection));
      

    // } else{
    //   let duration: any;
    //     this.headerobj.hasOwnProperty("jobDuration")
    //       ? (duration = this.headerobj.jobDuration.split(":"))
    //        : this.headerobj.hasOwnProperty("duration")
    //         ? (duration = this.headerobj.duration.split(":"))
    //         : "";
  
  
    //     this.timemanage.estEditHoursSelection = parseInt(duration[0]);
    //     console.log("hours2--->" , this.timemanage.estEditHoursSelection);
    //     this.timemanage.estEditMinuteSelection = parseInt(duration[1]);
    // }

    // if (this.isSeriesClicked) {
    //   alert(1);
    //   (this.timemanage.estEditHoursSelection = parseInt(
    //     localStorage.getItem("seriesHours")
    //   )),
    //     (this.timemanage.estEditMinuteSelection = parseInt(
    //       localStorage.getItem("seriesMins")
    //     ));
    // } else {
    //   alert(2);
    //   let duration: any;
    //   this.headerobj.hasOwnProperty("jobDuration")
    //     ? (duration = this.headerobj.jobDuration.split(":"))
    //      : this.headerobj.hasOwnProperty("duration")
    //       ? (duration = this.headerobj.duration.split(":"))
    //       : "";

    //   this.timemanage.estEditHoursSelection = parseInt(duration[0]);
    //   this.timemanage.estEditMinuteSelection = parseInt(duration[1]);
    //   console.log("duration", this.timemanage.estEditHoursSelection);

    // }
    let duration: any;

    // tbl.hasOwnProperty("jobDuration")
    // (console.log("inside duration 2----", tbl.jobDuration[0]))
    // ? (duration = tbl.jobDuration.split(","))
    //     (console.log("inside duration 1----", tbl.jobDuration))
    //  tbl.hasOwnProperty("duration")
    //   ? (duration = tbl.duration.split(","))
    //     (console.log("inside duration 2----", tbl.duration))

    //   : "";

    if(tbl.duration){
      this.timemanage.estEditHoursSelection = parseInt(tbl.duration[0]);
      this.timemanage.estEditMinuteSelection = parseInt(tbl.duration[1]);
    } else if(tbl.jobDuration){
      this.timemanage.estEditHoursSelection =tbl.jobDuration.split(":");
      this.timemanage.estEditHoursSelection = parseInt(this.timemanage.estEditHoursSelection[0]);
      this.timemanage.estEditMinuteSelection = tbl.jobDuration.split(':');
      this.timemanage.estEditMinuteSelection = parseInt(this.timemanage.estEditMinuteSelection[1]);
      // this.timemanage.estEditMinuteSelection = parseInt(tbl.duration[1]);
    } else if(this.headerobj.jobDuration){
      this.timemanage.estEditHoursSelection = this.headerobj.jobDuration.hours;
      this.timemanage.estEditHoursSelection = parseInt(this.timemanage.estEditHoursSelection);
      this.timemanage.estEditMinuteSelection = this.headerobj.jobDuration.minutes;
      this.timemanage.estEditMinuteSelection = parseInt(this.timemanage.estEditMinuteSelection);
    } else if(this.headerobj.duration){
      var dur = this.headerobj.duration.split(':');
      this.timemanage.estEditHoursSelection = parseInt(dur[0]);
      this.timemanage.estEditMinuteSelection = parseInt(dur[1]);
    }

 
  console.log("duration", this.timemanage.estEditHoursSelection);
    console.log("fgf", this.startDate);

  }

  reviewDateEvent() {
    this.isReviewDateShown = !this.isReviewDateShown;
    this.isReviewTimeShown = false;
  }

  closeDate() {
    var d = localStorage.getItem("cancelDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    this.isReviewDateShown = false;
  }

  applyDate() {
    var d = localStorage.getItem("singleDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    localStorage.setItem("startDates", d);
    localStorage.setItem("cancelDate", d);
    this.isRangeStartShown = false;
    this.isReviewDateShown = false;
  }

  reviewTimeEvent(id: any) {
    this.isReviewTimeShown = !this.isReviewTimeShown;
    this.isReviewDateShown = false;
  }

  closeTime() {
    this.isReviewTimeShown = false;
  }

  increaseHrs() {
    var hrs = parseInt(this.timemanage.tphours) + 1;
    this.disableDecreaseHrs = false;
    if (hrs >= 12) {
      this.timemanage.tphours = 12;
      this.disableIncreaseHrs = true;
    } else {
      this.timemanage.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrs = false;
    }

    console.log("hours--->",this.timemanage.tphours);
    
  }

  decreaseHrs() {
    var hrs = parseInt(this.timemanage.tphours) - 1;
    this.disableIncreaseHrs = false;
    if (hrs <= 0) {
      this.timemanage.tphours = "00";
      this.disableDecreaseHrs = true;
    } else {
      this.timemanage.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrs = false;
    }

    console.log("hours--->",this.timemanage.tphours);
  }

  increaseMins() {
    var mins = parseInt(this.timemanage.tpminutes) + 1;
    this.disableDecreaseMins = false;
    if (mins > 59) {
      this.disableIncreaseMins = true;
    } else {
      this.disableIncreaseMins = false;
      this.timemanage.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMins() {
    var mins = parseInt(this.timemanage.tpminutes);
    this.disableIncreaseMins = false;
    if (mins === 0) {
      this.disableDecreaseMins = true;
      this.timemanage.tpminutes = "00";
    } else {
      mins = parseInt(this.timemanage.tpminutes) - 1;
      this.disableDecreaseMins = false;
      this.timemanage.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  changetimeformat() {
    var f = this.timemanage.tptype;
    f === "AM" ? (this.timemanage.tptype = "PM") : (this.timemanage.tptype = "AM");
  }

  estEditHoursEvent(e: any) {
    var hrs = parseInt(e.target.value);
    if (hrs === 24) {
      this.timemanage.estEditMinuteSelection = 0;
      this.estEditMintues = Array(1)
        .fill(0)
        .map((x, i) => i);
    } else {
      this.estEditMintues = Array(60)
        .fill(0)
        .map((x, i) => i);
    }
    localStorage.setItem("seriesHours", this.timemanage.estEditHoursSelection.toString());
    localStorage.setItem("seriesMins", this.timemanage.estEditMinuteSelection.toString());
  }

  estEditMinutesEvent(e: any) {
    var mins = parseInt(e.target.value);
    var hrs = this.timemanage.estEditHoursSelection;
    if (hrs === 0) {
      this.isFailure = true;
      this.failureMessage = "Should be greater than 0";
    }
    localStorage.setItem("seriesHours", this.timemanage.estEditHoursSelection.toString());
    localStorage.setItem("seriesMins", this.timemanage.estEditMinuteSelection.toString());
  }

  onChangeMachine(e: any) {
    this.machineId = e.target.value;
    this.editMachineId = e.target.value;
    this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;
  }

  cancelSchedule(id: any) {
    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? f.isfold === true
          ? (f.isfold = false)
          : (f.isfold = true)
        : ""
    );
  }

  resetSchedule(id: any,table:any) {
    
    this.isEdited = false;
    this.chartExpandEvent(id,table);
  }

  resetMtnSchedule(id: any, occid: any) {
    this.isEdited = false;
    this.chartExpandForMtnEvent(id, occid);
  }

  // Here
  filterModel() {
    this.isFilterModelShown = true;
    var x = document.getElementsByTagName("html")[0];
    x.classList.add("overflowYHide");
  }

  closeFilterModel() {
    this.isFilterModelShown = false;
    var x = document.getElementsByTagName("html")[0];
    x.classList.remove("overflowYHide");
  }

  applyFilter() {
    this.isFilterModelShown = false;
    var x = document.getElementsByTagName("html")[0];
    x.classList.remove("overflowYHide");
    var machineIds = [];
    var botIds = [];
    var systemIds = [];
    var obj = {};

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    console.log("isFilter", "1");
    console.log("machineIds", this.machinesSelectedArray);
    console.log("botIds", this.jobsSelectedArray);
    console.log("systemIds here----", this.MtnSelectedArray);

    this.machinesSelectedArray.map((f: any) =>
      f.mchecked ? machineIds.push(parseInt(f.machineId)) : ""
    );

    this.searchMachinefilter = this.machinesSelectedArray;

    this.jobsSelectedArray.map((f: any) =>
      f.bchecked ? botIds.push(parseInt(f.botId)) : ""
    );

    this.MtnSelectedArray.map((f: any) =>
      f.checked
        ? systemIds.push(parseInt(f.systemId))
        : systemIds.push(parseInt(f.systemId))
    );

    obj = {
      isFilter: true,
      mids: machineIds,
      bids: botIds,
      sids: systemIds,
    };

    machineIds.length === 0 && botIds.length === 0 && systemIds.length === 0
      ? (localStorage.setItem("isFilter", "false"),
        (this.isfilterEnabled = false))
      : (localStorage.setItem("isFilter", "true"),
        (this.isfilterEnabled = true));

    //localStorage.setItem("isFilter", "true");
    localStorage.setItem("mids", JSON.stringify(machineIds));
    localStorage.setItem("bids", JSON.stringify(botIds));
    localStorage.setItem("sids", JSON.stringify(systemIds));

    this.refreshScheduleTab();
    this.callbackgetTableView(startRange, endRange, this.masterEnvId);
  }

  changefilterOption(e: any) {
    this.isLoadingIcon = true;
    this.filtertype = e.target.value.toString();
    var uniqueMachine: any = [];
    var uniqueJob: any = [];
    this.machinesSelectedArray = [];
    this.searchMachinefilter = [];
    this.jobsSelectedArray = [];
    this.machinesFilterArray = [];
    this.jobsFilterArray = [];
    this.searchjobfilterRes = [];

    this._restService
      .getLeftPanelData(
        this.environment,
        this.filtertype,
        this.limitselection,
        this.autoselectmaintenance,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.MtnfilterArray = []),
          (this.searchMaintenance = []),
          (this.machinejobArray = []),
          (this.MtnfilterArray = f.FilterRes.level2List),
          this.MtnfilterArray.map((f: any) => (f.checked = false)),
          (this.searchMaintenance = this.MtnfilterArray),
          (this.machinejobArray = f.FilterRes.leftPanelMachineBotRes),
          this.machinejobArray.map(
            (f: any) => ((f.mchecked = false), (f.bchecked = false))
          ),
          (uniqueMachine = this.machinejobArray.reduce((u: any, o: any) => {
            if (!u.some((obj: any) => obj.machineId === o.machineId)) {
              u.push(o);
            }
            return u;
          }, [])),
          uniqueMachine.map((m: any) =>
            m.machineId !== null && m.botId !== null
              ? this.machinesFilterArray.push(m)
              : ""
          ),
          (uniqueJob = this.machinejobArray.reduce((u: any, o: any) => {
            if (!u.some((obj: any) => obj.botId === o.botId)) {
              u.push(o);
            }
            return u;
          }, [])),
          uniqueJob.map((m: any) =>
            m.machineId !== null && m.botId !== null
              ? this.jobsFilterArray.push(m)
              : ""
          ),
          (this.searchjobfilterRes = this.jobsFilterArray),
          (this.machinesSearchArray = this.machinesFilterArray),
          (this.jobsSearchArray = this.jobsFilterArray),
          console.log("Machine---->", this.machinesFilterArray),
          console.log("Jobs---->", this.jobsFilterArray),
          (this.isLoadingIcon = false)
        )
      );
  }

  onMachineClick() {
    this.isMachineExpand = !this.isMachineExpand;
  }

  onJobsClick() {
    this.isJobExpand = !this.isJobExpand;
  }

  onMaintenanceClick() {
    this.isMaintenanceExpand = !this.isMaintenanceExpand;
  }

  searchMachinestoJob(e: any) {
    var l = e.target.value.toString().toLowerCase();
    this.machinesSearchArray = [];
    l.length > 0
      ? this.machinesFilterArray.filter((f: any) =>
        f.MachineName.toLowerCase().includes(l)
          ? this.machinesSearchArray.push(f)
          : ""
      )
      : (this.machinesSearchArray = this.machinesFilterArray);
  }

  searchJobs(e: any) {
    console.log("this.jobsSelectedArray", this.jobsSelectedArray);
    var l = e.target.value.toString().toLowerCase();
    this.machinestoJob = [];
    l.length > 0
      ? this.jobsSelectedArray.filter((f: any) =>
        f.Alias.toLowerCase().includes(l) ? this.machinestoJob.push(f) : ""
      )
      : (this.machinestoJob = this.jobsSelectedArray);
  }

  onMaintenanceSelect(e: any, id: any) {
    var v = e.target.checked;
    this.MtnfilterArray.map((m: any) =>
      m.systemId === id
        ? ((m.checked = e.target.checked),
          v ? this.MtnSelectedArray.push(m) : this.MtnSelectedArray.pop(m))
        : ""
    );
  }

  searchjobfilter(e: any) {
    var v = e.target.value.toString().toLowerCase();
    this.searchjobfilterRes = [];
    v.length > 0
      ? this.jobsFilterArray.filter((f: any) =>
        f.Alias.toLowerCase().includes(v)
          ? this.searchjobfilterRes.push(f)
          : ""
      )
      : (this.searchjobfilterRes = this.jobsFilterArray);

    console.log(this.jobsFilterArray);
  }

  searchMachinefilterEvent(e: any) {
    var v = e.target.value.toString().toLowerCase();
    this.searchMachinefilter = [];

    v.length > 0
      ? this.machinesSelectedArray.filter((f: any) =>
        f.MachineName.toLowerCase().includes(v)
          ? this.searchMachinefilter.push(f)
          : ""
      )
      : (this.searchMachinefilter = this.machinesSelectedArray);

    console.log(this.machinesSelectedArray);
  }

  searchMaintenanceEvent(e: any) {
    var v = e.target.value.toString().toLowerCase();
    console.log(this.MtnfilterArray);
    this.searchMaintenance = [];
    v.length > 0
      ? this.MtnfilterArray.filter((f: any) =>
        f.category_Name.toLowerCase().includes(v)
          ? this.searchMaintenance.push(f)
          : ""
      )
      : (this.searchMaintenance = this.MtnfilterArray);
  }

  onMachinetoJobSelect(e: any, id: any) {
    var v = e.target.checked;
    var removedItems: any = [];

    this.machinesFilterArray.map((m: any) =>
      m.machineId === id
        ? ((m.mchecked = e.target.checked),
          v
            ? this.machinesSelectedArray.push(m)
            : this.machinesSelectedArray.pop(m))
        : ""
    );

    console.log("0", this.machinesSelectedArray);

    this.searchMachinefilter = this.machinesSelectedArray;

    if (v) {
      this.machinejobArray.map((j: any) =>
        j.machineId === id && j.machineId !== null && j.botId !== null
          ? this.jStep1.push(j)
          : ""
      );
      console.log("1", this.jStep1);
    } else {
      this.jStep1.filter((j: any) =>
        j.machineId === id ? ((j.bchecked = false), (j.mchecked = false)) : ""
      );
      removedItems = this.jStep1.filter((j: any) => j.machineId !== id);
      this.jStep1 = removedItems;
      console.log("2", this.jStep1);
    }

    this.jStep2 = this.jStep1.reduce((u: any, o: any) => {
      if (!u.some((obj: any) => obj.botId === o.botId)) {
        u.push(o);
      }
      return u;
    }, []);

    console.log("3", this.jStep2);
    this.jobsSelectedArray = this.jStep2;
    this.machinestoJob = this.jStep2;
  }

  onJobtoMachineSelect(e: any, id: any) {
    var v = e.target.checked;
    var removedItems: any = [];
    this.jobsFilterArray.map((m: any) =>
      m.botId === id
        ? ((m.bchecked = e.target.checked),
          v ? this.jobsSelectedArray.push(m) : this.jobsSelectedArray.push(m))
        : ""
    );

    if (v) {
      this.machinejobArray.map((j: any) =>
        j.botId === id ? this.mStep1.push(j) : ""
      );
      console.log("1", this.mStep1);
    } else {
      this.mStep1.filter((j: any) =>
        j.botId === id ? ((j.bchecked = false), (j.mchecked = false)) : ""
      );
      removedItems = this.mStep1.filter((j: any) => j.botId !== id);
      this.mStep1 = removedItems;
      console.log("2", this.mStep1);
    }

    this.mStep2 = this.mStep1.reduce((u: any, o: any) => {
      if (!u.some((obj: any) => obj.machineId === o.machineId)) {
        u.push(o);
      }
      return u;
    }, []);

    console.log("3", this.mStep2);
    this.machinesSelectedArray = this.mStep2;
    this.searchMachinefilter = this.machinesSelectedArray;
  }

  onJobSelect(e: any, id: any) {
    this.jobsSelectedArray.map((j: any) =>
      j.botId === id ? (j.bchecked = e.target.checked) : ""
    );
    console.log("job clicked", this.jobsSelectedArray);
  }

  onMachineSelect(e: any, id: any) {
    this.machinesSelectedArray.map((j: any) =>
      j.machineId === id ? (j.mchecked = e.target.checked) : ""
    );

    console.log("Machine clicked", this.machinesSelectedArray);
  }

  selectMFArray() {
    this.machinesFilterArray.map(
      (m: any) => ((m.mchecked = true), this.machinesSelectedArray.push(m))
    );

    this.searchMachinefilter = this.machinesSelectedArray;

    this.machinejobArray.map((j: any) =>
      j.machineId !== null && j.botId !== null ? this.jStep1.push(j) : ""
    );

    this.jStep2 = this.jStep1.reduce((u: any, o: any) => {
      if (!u.some((obj: any) => obj.botId === o.botId)) {
        u.push(o);
      }
      return u;
    }, []);

    console.log("2", this.jStep2);
    this.jobsSelectedArray = this.jStep2;
  }

  clearMFArray() {
    this.machinesFilterArray.map(
      (m: any) => ((m.mchecked = false), (m.bchecked = false))
    );
    this.searchMachineInput = "";
    this.machinesSearchArray = this.machinesFilterArray;
    this.jobsSelectedArray.map((j: any) => (j.bchecked = false));
    this.machinesSelectedArray = [];
    this.searchMachinefilter = [];
    this.jobsSelectedArray = [];
  }

  selectJSArray() {
    this.jobsSelectedArray.map((j: any) => (j.bchecked = true));
    this.machinestoJob = this.jobsSelectedArray;
    this.searchJobsInput = "";
  }

  clearJSArray() {
    this.jobsSelectedArray.map((j: any) => (j.bchecked = false));
    this.machinestoJob = this.jobsSelectedArray;
    this.searchJobsInput = "";
  }

  clearJFArray() {
    this.jobsFilterArray.map(
      (m: any) => ((m.mchecked = false), (m.bchecked = false))
    );
    this.searchjobfilterRes = this.jobsFilterArray;
    this.machinesSelectedArray.map((j: any) => (j.mchecked = false));
    this.machinesSelectedArray = [];
    this.searchMachinefilter = [];
    this.jobsSelectedArray = [];
  }

  selectJFArray() {
    this.jobsFilterArray.map(
      (m: any) => ((m.bchecked = true), this.jobsSelectedArray.push(m))
    );

    this.searchjobfilterRes = this.jobsFilterArray;

    this.machinejobArray.map((j: any) =>
      j.machineId !== null && j.botId !== null ? this.mStep1.push(j) : ""
    );

    this.mStep2 = this.mStep1.reduce((u: any, o: any) => {
      if (!u.some((obj: any) => obj.machineId === o.machineId)) {
        u.push(o);
      }
      return u;
    }, []);

    console.log("2", this.mStep2);
    this.machinesSelectedArray = this.mStep2;
    this.searchMachinefilter = this.machinesSelectedArray;
  }

  clearMSArray() {
    this.machinesSelectedArray.map((j: any) => (j.mchecked = false));
    this.searchMachinefilter = this.machinesSelectedArray;
  }

  selectMSArray() {
    this.machinesSelectedArray.map((j: any) => (j.mchecked = true));
    this.searchMachinefilter = this.machinesSelectedArray;
  }

  selectMtArray() {
    this.MtnfilterArray.map((j: any) => (j.checked = true));
    this.searchMaintenance = this.MtnfilterArray;
    this.MtnSelectedArray = this.MtnfilterArray;
  }

  clearMtArray() {
    this.MtnfilterArray.map((j: any) => (j.checked = false));
    this.searchMaintenance = this.MtnfilterArray;
    this.MtnSelectedArray = [];
  }

  onLimitSelect(e: any) {
    this.lsValue = e.target.value;
    e.target.value ? (this.limitselection = "1") : (this.limitselection = "2");
  }

  onAutoSelect(e: any) {
    console.log("Maari", this.searchMaintenance);
    e.target.checked
      ? ((this.autoselectmaintenance = "1"),
        this.searchMaintenance.map(
          (f: any) => ((f.checked = true), this.MtnSelectedArray.push(f))
        ))
      : ((this.autoselectmaintenance = "2"),
        this.clearMtArray(),
        (this.MtnSelectedArray = []));
  }



  updateScheduleSeries(occid: any,tbl:any) {

    console.log("entry of update series job");

    console.log("table obj-----", tbl);

    var date = localStorage.getItem('singleDate');
    var newdate = date.split("/").reverse().join("-");
    var time = newdate + ' ' + this.timemanage.tphours + ':' + this.timemanage.tpminutes + ':' + '00';
    time = this.convertToTimezone1(time);
    time = time.toString();
    console.log("timemanage----", time);

    let  dateArr = [];
    dateArr.push(time);

    let occuranceId = this.timemanage.OccuranceId;
    console.log("occ---", occuranceId);
    
    let obj = this.tableobjBackup.filter(function (item) {
      return item.rowid !== occuranceId;
    });
    obj = this.convertToTimezone1(obj);


    dateArr.push(obj[0].startDateBefore);

    this.tableobjBackup = this.tableobj;
    
  console.log("final array---->", dateArr);
  
    
    this.isLoadingIcon = true;
    this.isDifferentTimezone = true;
    var count = 0;
    console.log("tphours", this.timemanage.tphours);
    console.log("tpminutes", this.timemanage.tpminutes);
    console.log("tptype", this.timemanage.tptype);


    var ty = this.timemanage.tptype === "AM" ? this.timemanage.tphours : parseInt(this.timemanage.tphours) + 12;

    var t = this.tableobj;

    // var sd = (
    //   new Date(this.startDate).getFullYear() +
    //   "-" +
    //   (new Date(this.startDate).getMonth() + 1) +
    //   "-" +
    //   new Date(this.startDate).getDate() +
    //   " " +
    //   ty +
    //   ":" +
    //   this.timemanage.tpminutes +
    //   ":" +
    //   "00"
    // ).toString();

    // console.log("sd--->", sd);
    

    // this.editedStartDateArray.push(sd);


    t.filter((f: any) =>
      f.rowid === occid
        ? (f.NewStart = (
          new Date(this.startDate).getFullYear() +
          "-" +
          (new Date(this.startDate).getMonth() + 1) +
          "-" +
          new Date(this.startDate).getDate() +
          " " +
          ty +
          ":" +
          this.timemanage.tpminutes +
          ":" +
          "00"
        ).toString())
        : ""
    );

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );

    // this.tableobj.map((f: any) =>
    //   f.rowid !== this.expandRowId
    //     ? f.start === d
    //       ? ((this.isLoadingIcon = false),
    //         (count = count + 1),
    //         (this.isFailure = true),
    //         (this.failureMessage = "Selected date is already exists"))
    //       : ""
    //     : ""
    // );

    // this.occID = occid;
    // this.editedStartDateArray = [];
    // this.tableobj = t;
    // this.tableobj;
    // this.editedStartDateArray.push((this.startDate));
    // console.log("editedstartdate---->", this.tableobj);
    // this.estHoursSelection = this.timemanage.estEditHoursSelection;
    // console.log("ttttttt---->", this.editedStartDateArray.push(dateArr));/
    

    // t.filter((f: any) => 
    
    // this.editedStartDateArray.push(this.convertToTimezone1(f.NewStart)));
    


    count === 0
      ? this.timemanage.estEditHoursSelection === "0" &&
        this.timemanage.estEditMinuteSelection === "0"
        ? ((this.isLoadingIcon = false),
          (this.isFailure = true),
          (this.failureMessage = "Estimated duration time is required"))
        : this._restService
          .createJobSchedule(
            // this.nrjEnvironment,
            // this.nrjjob,
            // this.nrjdescription,
            // 3,
            // this.editedStartDateArray,
            // this.editMachineId,
            // this.estHoursSelection,
            // this.timemanage.estEditMinuteSelection,
            // false,
            // false,
            // 0,
            // this.masterEnvId
                  this.environment,
                  this.botID,
                  this.headerobj.description,
                  3,
                  dateArr,
                  this.editMachineId,
                  this.timemanage.estEditHoursSelection,
                  this.timemanage.estEditMinuteSelection,
                  false,
                  true,
                  occid,
                  // ['1563','1564'],
                  this.masterEnvId
          )
          .pipe(
            catchError((e) => {
              (this.isLoadingIcon = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.response
                  ? e.error.response
                  : e.error.StatusInfo);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              console.log("createJobSchedule", occuranceId),
              (this.jobRecurringRes = f.scheduleListRes),
              
              (this.timemanage.OccuranceId = ''),
              (this.tableobj = []),
              (this.headerobj = f.scheduleListRes.Header),
              (this.machineobj = f.scheduleListRes.machineList),
              (this.tableobj = f.scheduleListRes.OccuranceTable),
              this.tableobj.filter((m: any) => (m.isfold = false)),
              this.tableobj.filter(
                (m: any, index: any) => (m.rowid = index + 1)
              ),
              this.tableobj.filter(
                (m: any, index: any) => (
                  (m.startDateBefore = (m.NewStart)),
                  (m.endDateBefore = (m.NewEnd)),
                  (m.NewStart = this.timezoneConvert(m.NewStart)),
                  (m.NewEnd = this.timezoneConvert(m.NewEnd)),

                  console.log("end 12", JSON.stringify(m.startDateBefore))
                ),
              ),
              console.log("table 1", this.tableobj),
              this.tableobj.filter((m: any) =>
                m.hasOwnProperty("scheduleArr")
                  ? m.scheduleArr.filter(
                    (d: any) => (
                      (d.start = this.timezoneConvert(d.startDate)),
                      (d.end = this.timezoneConvert(d.endDate)),
                      (d.startHour = new Date(d.start).getHours()),
                      (d.startMinutes = new Date(d.start).getMinutes()),
                      (d.endHours = new Date(d.end).getHours()),
                      (d.endMinutes = new Date(d.end).getMinutes())
                    )
                  )
                  : ""
              ),
              this.tableobj.filter((m: any) =>
                m.hasOwnProperty("scheduleArr")
                  ? m.scheduleArr.filter(
                    (d: any) => (
                      (d.position =
                        parseInt(d.startHour + 1) * 70 +
                        (parseInt(d.startMinutes) / 60) * 70),
                      (d.length =
                        parseInt(d.endHours + 1) * 70 +
                        (parseInt(d.endMinutes) / 60) * 70)
                    )
                  )
                  : ""
              ),
              this.tableobj.filter((m: any) =>
                m.hasOwnProperty("MaintanceListArr")
                  ? m.MaintanceListArr.length > 0
                    ? m.MaintanceListArr.filter(
                      (d: any) => (
                        (d.startHour = new Date(d.startDate).getHours()),
                        (d.startMinutes = new Date(
                          d.startDate
                        ).getMinutes()),
                        (d.endHours = new Date(d.endDate).getHours()),
                        (d.endMinutes = new Date(d.endDate).getMinutes()),
                        (d.position =
                          parseInt(d.startHour + 1) * 70 +
                          (parseInt(d.startMinutes) / 60) * 70),
                        (d.length =
                          parseInt(d.endHours + 1) * 70 +
                          (parseInt(d.endMinutes) / 60) * 70)
                      )
                    )
                    : ""
                  : ""
              ),
              console.log("table 2", this.jobRecurringRes),
              (this.isLoadingIcon = false)
            )
          )
      : "";
  }

  updateSchedule(occid: any) {

    console.log("enry of update job");
    
    this.isLoadingIcon = true;
    console.log("occid", occid);
    console.log("startDate", this.startDate);
    console.log("tphours", this.timemanage.tphours);
    console.log("tpminutes", this.timemanage.tpminutes);
    console.log("tptype", this.timemanage.tptype);
    console.log("estEditHoursSelection", this.timemanage.estEditHoursSelection);
    console.log("estEditMinuteSelection", this.timemanage.estEditMinuteSelection);
    console.log("editMachineId", this.editMachineId);

    this.occID = occid;
    this.editedStartDateArray = [];

    var ty = this.timemanage.tptype === "AM" ? this.timemanage.tphours : parseInt(this.timemanage.tphours) + 12;

    var sd = (
      new Date(this.startDate).getFullYear() +
      "-" +
      (new Date(this.startDate).getMonth() + 1) +
      "-" +
      new Date(this.startDate).getDate() +
      " " +
      ty +
      ":" +
      this.timemanage.tpminutes +
      ":" +
      "00"
    ).toString();

    this.editedStartDateArray.push(sd);

    this._restService
      .createJobSchedule(
        this.environment,
        this.botID,
        this.headerobj.description,
        3,
        this.editedStartDateArray ,
        this.editMachineId,
        this.timemanage.estEditHoursSelection,
        this.timemanage.estEditMinuteSelection,
        false,
        true,
        occid,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("edit update No occurance found", f),
          f.scheduleListRes === "No occurance found"
            ? ((this.isLoadingIcon = false),
              (this.isEditOccShown = false),
              (this.isInfoModelShown = true),
              (this.infoMessage = "No occurance found"))
            : (this.occurrenceResult = f.scheduleListRes),
          (this.tableobj = []),
          (this.isEdited = true),
          (this.headerobj = f.scheduleListRes.Header),
          (this.machineobj = f.scheduleListRes.machineList),
          (this.tableobj = f.scheduleListRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
             
              (m.startDateBefore = (m.NewStart)),
              (m.endDateBefore = (m.NewEnd)),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
              console.log("end 12", JSON.stringify(m.startDateBefore))
            ),
          ),
          //console.log("table 1", this.tableobj),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("scheduleArr")
              ? m.scheduleArr.filter(
                (d: any) => (
                  // this.addingHoursMinutes(d)
                  d.start = this.timezoneConvert(d.startDate),
                  d.end = this.timezoneConvert(d.endDate),

                  d.startHour = new Date(d.start).getHours(),
                  d.startMinutes = new Date(d.start).getMinutes(),
                  d.endHours = new Date(d.end).getHours(),
                  d.endMinutes = new Date(d.end).getMinutes(),
                  d.position =
                    parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70,
                  d.length =
                    parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70,
              
                  console.log("int--->" + d.startHour + 'end-->' + d.endHours)
                )
              )
              : ""
          ),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("scheduleArr")
              ? m.scheduleArr.filter(
                (d: any) => (
                  (d.position =
                    parseInt(d.startHour + 1) * 70 +
                    (parseInt(d.startMinutes) / 60) * 70),
                  (d.length =
                    parseInt(d.endHours + 1) * 70 +
                    (parseInt(d.endMinutes) / 60) * 70)
                )
              )
              : ""
          ),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("MaintanceListArr")
              ? m.MaintanceListArr.length > 0
                ? m.MaintanceListArr.filter(
                  (d: any) => (
                    (d.startHour = new Date(d.startDate).getHours()),
                    (d.startMinutes = new Date(d.startDate).getMinutes()),
                    (d.endHours = new Date(d.endDate).getHours()),
                    (d.endMinutes = new Date(d.endDate).getMinutes()),
                    (d.position =
                      parseInt(d.startHour + 1) * 70 +
                      (parseInt(d.startMinutes) / 60) * 70),
                    (d.length =
                      parseInt(d.endHours + 1) * 70 +
                      (parseInt(d.endMinutes) / 60) * 70)
                  )
                )
                : ""
              : ""
          ),
          (this.isLoadingIcon = false)
        )
      );
  }

  //Maari
  updateJobSeriesSchedule(occid: any) {
    this.isLoadingIcon = true;
    this.isSeriesClicked = true;
    var occuranceList = this.jobRecurringRes;

    this.editedStartDateArray = [];

    this.occID = occid;
    console.log("occ id-->" , this.occID);
    
    var ty = this.timemanage.tptype === "AM" ? this.timemanage.tphours : parseInt(this.timemanage.tphours) + 12;
    // this.startDate = this.convertToTimezone1(this.startDate);
    var sd = (
      new Date(this.startDate).getFullYear() +
      "-" +
      (new Date(this.startDate).getMonth() + 1) +
      "-" +
      new Date(this.startDate).getDate() +
      " " +
      ty +
      ":" +
      this.timemanage.tpminutes +
      ":" +
      "00"
    ).toString();
    //sd = this.convertToTimezone1(sd);

    console.log("editedstartdate---->", (this.timemanage.estEditHoursSelection));

    this.editedStartDateArray.push(sd);
    this.editedStartDateArray = (this.editedStartDateArray.flat());
    // this.editedStartDateArray = this.convertToTimezone1(this.editedStartDateArray)/

    

    // var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    // var s = sd.split("/").reverse().join("-");
    // var sdt = [];
    // this.editedStartDateArray.push(s);
    // console.log("dates--->" + JSON.stringify(sdt));
    // console.log("dates-->" + JSON.stringify((this.editedStartDateArray)));

    this._restService
      .createJobSchedule(
        this.environment,
        this.botID,
        this.headerobj.description,
        3,
        (this.editedStartDateArray),
        this.editMachineId,
        (this.timemanage.estEditHoursSelection),
        (this.timemanage.estEditMinuteSelection),
        false,
        true,
        this.occID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
    
        (f: any) => (
          this.jobRecurringRes.RecurringRes.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.OccuranceId) === parseInt(this.occID)
                ? Object.assign(m, f.scheduleListRes.OccuranceTable[0])
                : ""
          ),
          (this.tableobj = []),
          (this.headerobj = this.jobRecurringRes.RecurringRes.Header),
          (this.saveFrequency =
            this.jobRecurringRes.RecurringRes.Header.frequency),
          console.log("this.saveFrequency", this.saveFrequency),
          (this.machineobj = this.jobRecurringRes.RecurringRes.machineList),
          (this.tableobj = this.jobRecurringRes.RecurringRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          console.log("table 1", this.tableobj),
          console.log("Save Job Schedule", this.jobRecurringRes),
      
        
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("scheduleArr")
              ? m.scheduleArr.filter(
                (d: any) => (
                  // (d.NewStart = (d.NewStart))
                  (console.log("inside table obj-----",(m))),
                  (d.start = this.timezoneConvert(d.startDate)),
                  (d.end = this.timezoneConvert(d.endDate)),
                  (d.startHour = new Date(d.start).getHours()),
                  (d.startMinutes = new Date(d.start).getMinutes()),
                  (d.endHours = new Date(d.end).getHours()),
                  (d.endMinutes = new Date(d.end).getMinutes())
                )
              )
              : ""
          ),
          f.scheduleListRes.OccuranceTable.filter((m:any) => (
            (m.occ = f.scheduleListRes.OccuranceTable[0].occuranceId),
            console.log("data...." ,(f.scheduleListRes.OccuranceTable[0])),
            m.sstartbefore = f.scheduleListRes.OccuranceTable[0].NewStart,
            m.sendbefore = f.scheduleListRes.OccuranceTable[0].NewEnd,
            m.sstart = this.timezoneConvert(f.scheduleListRes.OccuranceTable[0].NewStart),
            m.send = this.timezoneConvert(f.scheduleListRes.OccuranceTable[0].NewEnd),


           this.tableobj.filter(function (item) {

                  if(item.OccuranceId === m.occ) {
                    
                  console.log("m---", (item.NewStart)),
                  (item.startDateBefore = m.sstartbefore),
                  (item.endDateBefore = m.sendbefore),
                  (item.NewStart = m.sstart),
                  (item.NewEnd = m.send)
                  } 
                  // else{
                  //   alert(2)
                  // }
                })            
          )
          ),
         
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("scheduleArr")
              ? m.scheduleArr.filter(
                (d: any) => (
                  (d.position =
                    parseInt(d.startHour + 1) * 70 +
                    (parseInt(d.startMinutes) / 60) * 70),
                  (d.length =
                    parseInt(d.endHours + 1) * 70 +
                    (parseInt(d.endMinutes) / 60) * 70)
                )
              )
              : ""
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              // (m.startDateBefore = (m.NewStart)),
              // (m.endDateBefore = (m.NewEnd)),
              // (m.NewStart = this.convertToTimezone(m.NewStart)),
              // (m.NewEnd = this.convertToTimezone(m.NewEnd)),
            
              console.log("end convert", (m))
            ),
          ),
          this.tableobj.filter((m: any) =>
            m.hasOwnProperty("MaintanceListArr")
              ? m.MaintanceListArr.length > 0
                ? m.MaintanceListArr.filter(
                  (d: any) => (
                    (d.startHour = new Date(d.startDate).getHours()),
                    (d.startMinutes = new Date(d.startDate).getMinutes()),
                    (d.endHours = new Date(d.endDate).getHours()),
                    (d.endMinutes = new Date(d.endDate).getMinutes()),
                    (d.position =
                      parseInt(d.startHour + 1) * 70 +
                      (parseInt(d.startMinutes) / 60) * 70),
                    (d.length =
                      parseInt(d.endHours + 1) * 70 +
                      (parseInt(d.endMinutes) / 60) * 70)
                  )
                )
                : ""
              : ""
          ),
          (this.isLoadingIcon = false),
          (this.isLoadingIcon = false)
        )

     
      );
  }

  rs4Event() {
    this.isEditJobSeriesShown = false;
    this.isSeriesClicked = false;
    this.isLoadingIcon = true;

    console.log("this.jobRecurringRes", this.jobRecurringRes);

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this.jobRecurringRes.RecurringRes.OccuranceTable.filter(
      (p: any) => (delete p.MaintanceListArr, delete p.scheduleArr)
    );

    this.jobRecurringRes.RecurringRes.OccuranceTable.filter((f: any) =>
      f.OccuranceId === this.occID
        ? (f.jobDuration = {
          hours: localStorage.getItem("seriesHours"),
          minutes: localStorage.getItem("seriesMins"),
        })
        : ""
    );

    this.jobRecurringRes.RecurringRes.OccuranceTable.filter((m:any) =>(
      //m.startDateBefore = m.NewStart,
      //m.endDateBefore = m.NewEnd,
      m.NewStart = (this.inverseTimezoneConvert(m.NewStart)),
      m.NewEnd = (this.inverseTimezoneConvert(m.NewEnd)),
      m.NewStart = new Date(m.NewStart).toISOString(),
      m.NewEnd = new Date(m.NewEnd).toISOString()
    )
    )

    console.log("this.jobRecurringRes", this.jobRecurringRes);

    this._restService
      .editSeriesOccurance(
        this.environment,
        this.jobRecurringRes.RecurringRes.Header,
        this.jobRecurringRes.RecurringRes.OccuranceTable,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Result", f),
          this.callbackgetTableView(startRange, endRange, this.masterEnvId),
          this.refreshScheduleTab(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoadingIcon = false)
        )
      );
  }


  jobOccurrenceEvent() {
    this.isEditOccShown = false;
    this.isLoadingIcon = true;

    console.log("Occ Result --->", this.occurrenceResult);
    let Header = this.occurrenceResult.Header;
    let flaggedMid = Header.flaggedMid !== undefined ? Header.flaggedMid : [];
    let OccuranceTable = this.occurrenceResult.OccuranceTable;
    console.log("Header", Header);
    console.log("OccuranceTable", OccuranceTable);

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

      let start = new Date(OccuranceTable[0].NewStart);
      console.log("occurance table--->", start);
      

    this._restService
      .editOccurance(
        OccuranceTable[0].occuranceId,
        this.environment,
        Header.description,
        this.inverseTimezoneConvert(OccuranceTable[0].NewStart),
        this.inverseTimezoneConvert(OccuranceTable[0].NewEnd),
        this.botID,
        Header.MachineId,
        OccuranceTable[0].Status,
        OccuranceTable[0].flagged,
        Header.jobDuration,
        flaggedMid,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("f", f),
          this.machineGroup.filter((mg2: any) =>
            mg2.hasOwnProperty("scheduleList")
              ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
              : ""
          ),
          this.callbackgetTableView(startRange, endRange, this.masterEnvId),
          this.refreshScheduleTab(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo)
        )
      );
  }

  callbackgetTableView = (startRange: any, endRange: any, mid: any) => {
    this._restService
      .getTableView(this.environment, startRange, endRange, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          //console.log("getTableView", f),
          (this.flagCount = 0),
          (this.actualArray = []),
          (this.getTableView = []),
          (this.filterArray = []),
          ((this.getTableView = f.TableRes.tableData),
            (this.actualArray = f.TableRes.tableData),
            (this.totalJobsCount = parseFloat(this.getTableView.length) / 7),
            (this.paginationLength =
              this.totalJobsCount % 1 === 0
                ? Math.round(this.totalJobsCount)
                : Math.round(this.totalJobsCount) + 1),
            this.loopingPagination(this.getTableView.length),
            this.actualArray.map(
              (f: any) => (
                (f.occurrences =
                  f.RecuringTotal === undefined
                    ? f.SScheduleCount + 0
                    : f.SScheduleCount + f.RecuringTotal),
                f.isFlagged !== undefined
                  ? f.isSchedule && f.isFlagged === 1
                    ? (this.flagCount = this.flagCount + 1)
                    : ""
                  : "",
                (f.StartDate = this.timezoneConvert(f.StartDate)),
                (f.EndDate = this.timezoneConvert(f.EndDate)),
                (f.start = new Date(f.StartDate).toString()),
                (f.end = new Date(f.EndDate).toString()),
                (f.StartFormatted = new Date(f.StartDate).toLocaleString()),
                (f.EndFormatted = new Date(f.EndDate).toLocaleString()),
                (f.type = f.isSchedule
                  ? "Job"
                  : f.isMaintenance
                    ? "Maintenance"
                    : ""),
                (f.Status =
                  f.isSchedule && f.isFlagged === 1
                    ? "Flagged"
                    : f.Sstatus === 2
                      ? "Conflict"
                      : f.Sstatus === 1 && f.deployed === 0
                        ? "Scheduled"
                        : f.Sstatus === 1 && f.deployed === 1
                          ? "Completed"
                          : f.Sstatus === 1 && f.deployed === 2
                            ? "Deployment failed"
                            : ""),
                (f.activity = (
                  f.isMaintenance ? f.moccuranceId : f.occuranceId
                ).toString()),
                (f.series = (
                  f.isSchedule
                    ? f.seriesId !== null
                      ? "SR" + f.seriesId
                      : ""
                    : f.isMaintenance
                      ? f.maintenanceSeriesId !== null
                        ? "M" + f.maintenanceSeriesId
                        : ""
                      : ""
                ).toString())
              )
            ),
            this.actualArray.map((f: any, index: any) =>
              index + 1 <= 7 ? this.filterArray.push(f) : ""
            ),
            console.log("Maari Yes --->", this.actualArray)),
          (this.isLoadingIcon = false)
        )
      );
  };

  closeJobModelShown() {
    this.isEditOccShown = false;
    this.isEditMtnOccShown = false;
    this.isEditJobSeriesShown = false;
    this.isEditMtnSeriesShown = false;
  }

  editMaintenance(mid: any, t: any) {
    this.isEditMtnOccShown = true;
    this.isLoadingIcon = true;
    this.mSingleOccId = mid;
    this._restService
      .getMaintenanceOccurance(this.environment, mid, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          this.mScheduleResponse = f,
          console.log("MSingle", f),
          (this.MSingleArray = f.maintenanceRes),
          (this.tableobj = []),
          (this.headerobj = f.maintenanceRes.headerObj),
          (this.tableobj = f.maintenanceRes.OccuranceTable),

          this.mSystemAccessList = this.tableobj[0].MaintenaceAccess.length ? 
                SystemUtils.convertAccessListToSystem(this.tableobj[0].MaintenaceAccess[0]) : 
                SystemUtils.createEnvAccess(this.headerobj.description, this.headerobj.envName),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          console.log("table 1", this.tableobj),
          this.tableobj.filter(
            (m: any, index: any) => (
            
              (m.startDateBefore = (m.NewStart)),
              (m.endDateBefore = (m.NewEnd)),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
              console.log("end 12", JSON.stringify(m.NewStart))
            ),
          ),
          this.tableobj.filter((m: any) =>
            SchedulerUtils.updateMaintenanceObject(m)
          ),
          console.log("table final ---->>>>>", this.tableobj),
          (this.isLoadingIcon = false)
        )
      );
  }

  updateMaintenanceSingle(mid: any) {
    console.log("entry of updation----");
    var hm = [];
    
    console.log("Point here---->", mid);
    let header = this.MSingleArray.headerObj;
    let msystemAccess = this.MSingleArray.OccuranceTable;
    console.log("Points header---->", header);
    console.log("Points msystemAccess---->", msystemAccess);

    let list = msystemAccess[0].MaintenaceAccess;
    let systemAccessList = [];

    list.map(
      (a: any) => (
        systemAccessList.push(a),
        a.hasOwnProperty("children")
          ? a.children.map(
            (b: any) => (
              systemAccessList.push(b),
              b.hasOwnProperty("children")
                ? b.children.map(
                  (c: any) => (
                    systemAccessList.push(c),
                    c.hasOwnProperty("children")
                      ? c.children.map(
                        (d: any) => (
                          systemAccessList.push(d),
                          d.hasOwnProperty("children")
                            ? d.children.map(
                              (f: any) => (
                                systemAccessList.push(f),
                                f.hasOwnProperty("children")
                                  ? f.children.map(
                                    (g: any) => (
                                      systemAccessList.push(g),
                                      g.hasOwnProperty("children")
                                        ? g.children.map(
                                          (h: any) => (
                                            systemAccessList.push(
                                              h
                                            ),
                                            h.hasOwnProperty(
                                              "children"
                                            )
                                              ? h.children.map(
                                                (j: any) => (
                                                  systemAccessList.push(
                                                    j
                                                  ),
                                                  j.hasOwnProperty(
                                                    "children"
                                                  )
                                                    ? j.children.map(
                                                      (
                                                        k: any
                                                      ) => (
                                                        systemAccessList.push(
                                                          k
                                                        ),
                                                        k.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? k.children.map(
                                                            (
                                                              l: any
                                                            ) =>
                                                              systemAccessList.push(
                                                                l
                                                              )
                                                          )
                                                          : ""
                                                      )
                                                    )
                                                    : ""
                                                )
                                              )
                                              : ""
                                          )
                                        )
                                        : ""
                                    )
                                  )
                                  : ""
                              )
                            )
                            : ""
                        )
                      )
                      : ""
                  )
                )
                : ""
            )
          )
          : ""
      )
    );

    systemAccessList.map(
      (a: any) => (
        a.hasOwnProperty("children") ? delete a.children : "",
        a.hasOwnProperty("envList") ? delete a.envList : ""
      )
    );

    console.log("Point System", systemAccessList);

    var shour =
      this.timemanage.tptype === "AM" ? this.timemanage.tphours : parseInt(this.timemanage.tphours) + 12;
      console.log("hours-->", shour);

    // var shour =
    // this.timemanage.tptype === "AM" ? this.timemanage.tphours : parseInt(this.timemanage.tphours) + 12;

    var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    var s = sd.split("/").reverse().join("-");
    var sdt = [];
    var ds = [];
    ds.push(s);
    console.log("dates--->" + JSON.stringify(sdt));

    var dates = ds + ' ' + this.timemanage.tphours + ':' + this.timemanage.tpminutes + ':' + '00';
    //dates = this.convertToTimezone1(dates);

    var hour = new Date(dates).getHours().toString().padStart(2, "0");
    var minute = new Date(dates).getMinutes().toString().padStart(2, "0");

    var range = {
      startTime: {
        hours: hour.toString(),
        minutes: minute.toString(),
      },
      end: {
        endTime: {
          hours: "00",
          minutes: "00",
          totalDuration: "00",
        },
        duration: {
          hours: this.timemanage.estEditHoursSelection.toString(),
          minutes: this.timemanage.estEditMinuteSelection.toString(),
        },
        isEndTime: false,
      },
    };
    // var sm = localStorage.getItem('startDates');

    var sm =new Date(this.startDate).toLocaleDateString("fr-CA");
    sm = sm.split("/").reverse().join("-");
    var d = [];
    d.push(sm);



    this._restService
      .createMaintenanceSchedule(
        header.activityLabel,
        this.environment,
        systemAccessList,
        header.description,
        d,
        range,
        true,
        this.mSingleOccId,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log(f),
          (this.MSingleRes = f.maintenanceRes),
          (this.tableobj = []),
          (this.headerobj = f.maintenanceRes.headerObj),
          (this.tableobj = f.maintenanceRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          console.log("table 1", this.tableobj),
          // this.headerobj.hasOwnProperty("duration")
          // ? ((hm = this.headerobj.duration.split(":")),
          //   (this.headerobj.hours = hm[0]),
          //   (this.headerobj.mins = hm[1]))
          // : "",
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.startDateBefore = (m.NewStart)),
              (m.endDateBefore =(m.NewEnd)),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
           
              console.log("end 12", this.timezoneConvert(m.NewStart))
            ),
          ),

          this.tableobj.filter((m: any) =>
          m.hasOwnProperty("MaintenaceAccess")
            ? m.MaintenaceAccess.filter((a: any) => (
              a.hasOwnProperty("Mlist")
              ? a.Mlist.filter((d:any) =>(
                d.start = this.timezoneConvert(d.startDate),
                d.end = this.timezoneConvert(d.endDate),
                d.startHour = new Date(d.start).getHours(),
                d.startMinutes = new Date(d.start).getMinutes(),
                d.endHours = new Date(d.end).getHours(),
                d.endMinutes = new Date(d.end).getMinutes(),
                d.position =
                parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70,
                d.length =
                parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70,
                console.log("int--->" + d.startDate + 'end-->' + d.endHours)
              ))
           :""
            )
            )
            : ""
        ),

          // this.tableobj.filter((m: any) =>
          //   m.hasOwnProperty("MaintenaceAccess")
          //     ? m.MaintenaceAccess.filter(
          //       (a: any) => (
          //         a.hasOwnProperty("Mlist")
          //           ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
          //           : "",
          //         a.hasOwnProperty("children")
          //           ? a.children.filter(
          //             (b: any) => (
          //               b.hasOwnProperty("Mlist")
          //                 ? b.Mlist.filter((dt: any) =>
          //                   this.addingHoursMinutes(dt)
          //                 )
          //                 : "",
          //               b.hasOwnProperty("children")
          //                 ? b.children.filter(
          //                   (c: any) => (
          //                     c.hasOwnProperty("Mlist")
          //                       ? c.Mlist.filter((dt: any) =>
          //                         this.addingHoursMinutes(dt)
          //                       )
          //                       : "",
          //                     c.hasOwnProperty("children")
          //                       ? c.children.filter(
          //                         (d: any) => (
          //                           d.hasOwnProperty("Mlist")
          //                             ? d.Mlist.filter((dt: any) =>
          //                               this.addingHoursMinutes(dt)
          //                             )
          //                             : "",
          //                           d.hasOwnProperty("children")
          //                             ? d.children.filter(
          //                               (f: any) => (
          //                                 f.hasOwnProperty("Mlist")
          //                                   ? f.Mlist.filter(
          //                                     (dt: any) =>
          //                                       this.addingHoursMinutes(
          //                                         dt
          //                                       )
          //                                   )
          //                                   : "",
          //                                 f.hasOwnProperty("children")
          //                                   ? f.children.filter(
          //                                     (g: any) => (
          //                                       g.hasOwnProperty(
          //                                         "Mlist"
          //                                       )
          //                                         ? g.Mlist.filter(
          //                                           (dt: any) =>
          //                                             this.addingHoursMinutes(
          //                                               dt
          //                                             )
          //                                         )
          //                                         : "",
          //                                       g.hasOwnProperty(
          //                                         "children"
          //                                       )
          //                                         ? g.children.filter(
          //                                           (h: any) => (
          //                                             h.hasOwnProperty(
          //                                               "Mlist"
          //                                             )
          //                                               ? h.Mlist.filter(
          //                                                 (
          //                                                   dt: any
          //                                                 ) =>
          //                                                   this.addingHoursMinutes(
          //                                                     dt
          //                                                   )
          //                                               )
          //                                               : "",
          //                                             h.hasOwnProperty(
          //                                               "children"
          //                                             )
          //                                               ? h.children.filter(
          //                                                 (
          //                                                   j: any
          //                                                 ) => (
          //                                                   j.hasOwnProperty(
          //                                                     "Mlist"
          //                                                   )
          //                                                     ? j.Mlist.filter(
          //                                                       (
          //                                                         dt: any
          //                                                       ) =>
          //                                                         this.addingHoursMinutes(
          //                                                           dt
          //                                                         )
          //                                                     )
          //                                                     : "",
          //                                                   j.hasOwnProperty(
          //                                                     "children"
          //                                                   )
          //                                                     ? j.children.filter(
          //                                                       (
          //                                                         k: any
          //                                                       ) => (
          //                                                         k.hasOwnProperty(
          //                                                           "Mlist"
          //                                                         )
          //                                                           ? k.Mlist.filter(
          //                                                             (
          //                                                               dt: any
          //                                                             ) =>
          //                                                               this.addingHoursMinutes(
          //                                                                 dt
          //                                                               )
          //                                                           )
          //                                                           : "",
          //                                                         k.hasOwnProperty(
          //                                                           "children"
          //                                                         )
          //                                                           ? k.children.filter(
          //                                                             (
          //                                                               l: any
          //                                                             ) => (
          //                                                               l.hasOwnProperty(
          //                                                                 "Mlist"
          //                                                               )
          //                                                                 ? l.Mlist.filter(
          //                                                                   (
          //                                                                     dt: any
          //                                                                   ) =>
          //                                                                     this.addingHoursMinutes(
          //                                                                       dt
          //                                                                     )
          //                                                                 )
          //                                                                 : "",
          //                                                               l.hasOwnProperty(
          //                                                                 "children"
          //                                                               )
          //                                                                 ? l.children.filter(
          //                                                                   (
          //                                                                     m: any
          //                                                                   ) =>
          //                                                                     m.hasOwnProperty(
          //                                                                       "Mlist"
          //                                                                     )
          //                                                                       ? m.Mlist.filter(
          //                                                                         (
          //                                                                           dt: any
          //                                                                         ) =>
          //                                                                           this.addingHoursMinutes(
          //                                                                             dt
          //                                                                           )
          //                                                                       )
          //                                                                       : ""
          //                                                                 )
          //                                                                 : ""
          //                                                             )
          //                                                           )
          //                                                           : ""
          //                                                       )
          //                                                     )
          //                                                     : ""
          //                                                 )
          //                                               )
          //                                               : ""
          //                                           )
          //                                         )
          //                                         : ""
          //                                     )
          //                                   )
          //                                   : ""
          //                               )
          //                             )
          //                             : ""
          //                         )
          //                       )
          //                       : ""
          //                   )
          //                 )
          //                 : ""
          //             )
          //           )
          //           : ""
          //       )
          //     )
          //     : ""
          // ),
          //console.log("table final ---->>>>>", this.tableobj),
          (this.isLoadingIcon = false)
        )
      );
  }

  msingleSave() {
    console.log("entry of edit--->");
    
    this.isLoadingIcon = true;
    //console.log("this.MSingleRes", this.MSingleRes);
    let header = this.MSingleRes.headerObj;
    let occuranceTable = this.MSingleRes.OccuranceTable;
    //console.log("header", header);
    //console.log("occuranceTable", occuranceTable);

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this._restService
      .editMOccurance(
        this.mSingleOccId,
        this.environment,
        header.activityLabel,
        header.description,
        occuranceTable[0].startDateBefore,
        occuranceTable[0].endDateBefore,
        header.duration,
        occuranceTable[0].Status,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("msingleSave", f),
          this.maintenanceGroup.filter((mg: any) =>
            mg.hasOwnProperty("maintenanceList")
              ? mg.maintenanceList.filter((f: any) => (f.dropdown = false))
              : ""
          ),
          (this.isEditMtnOccShown = false),
          this.callbackgetTableView(startRange, endRange, this.masterEnvId),
          this.refreshScheduleTab(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoadingIcon = false)
        )
      );
  }

  addingHoursMinutes(d: any) {
    // d.start = this.timezoneConvert(d.startDate);
    // d.end = this.timezoneConvert(d.endDate);
    d.startHour = new Date(d.startDate).getHours();
    d.startMinutes = new Date(d.startDate).getMinutes();
    d.endHours = new Date(d.endDate).getHours();
    d.endMinutes = new Date(d.endDate).getMinutes();
    d.position =
      parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
    d.length =
      parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;

    console.log("int--->" + d.startHour + 'end-->' + d.endHours);

  }

  editJobSeries(occid: any, sid: any, bid: any, txt: any) {
    console.log("entry of edit job series----");
    
    this.scheduleTxt = txt;
    this.isEditJobSeriesShown = true;
    this.botID = bid;
    this.occID = occid;
    this.isLoadingIcon = true;
    this._restService
      .getSeriesDetail(this.environment, sid, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("editJobSeries", f),
          (this.jobRecurringRes = f),
          this.jobScheduleResponse = new JobScheduleResponse(),
          (this.tableobj = []),
          this.jobScheduleResponse.scheduleListRes = f.RecurringRes,
          (this.headerobj = f.RecurringRes.Header),
          (this.headerobjBackup = f.RecurringRes.Header),
          (this.saveFrequency = f.RecurringRes.Header.frequency),
          console.log("this.saveFrequency", this.saveFrequency),
          (this.machineobj = f.RecurringRes.machineList),
          (this.tableobj = f.RecurringRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (p: any) => (
              localStorage.setItem("rowDuration", p.jobDuration),
              (p.duration = p.jobDuration.split(":")),
              (p.jobDuration = {
                hours: p.duration[0],
                minutes: p.duration[1],
              })
            )
          ),
          
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.startDateBefore = (m.NewStart)),
              (m.endDateBefore = (m.NewEnd)),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
            
              console.log("end 12", JSON.stringify(m.startDateBefore))
            ),
          ),
          this.tableobj.filter((m: any) =>
            SchedulerUtils.updateScheduleObject(m)
          ),
          (this.isLoadingIcon = false),
          console.log("Save Job Schedule", this.headerobj)
        )
      );
  }

  editMaintenanceSeries(sid: any, occid: any, txt: any) {
    console.log("firts entry of edit series-->")
    this.scheduleTxt = txt;
    this.isEditMtnSeriesShown = true;
    this.isLoadingIcon = true;
    this.mseriesid = sid;
    this.occID = occid;
    this._restService
      .getMaintenanceSeries(this.environment, sid, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log(f),
          (this.mtnRecurringRes = f),
          (this.tableobj = []),
          this.mScheduleResponse = new MaintenanceScheduleRes(),
          this.mScheduleResponse.maintenanceRes = f.response,
          (this.headerobj = f.response.headerObj),
          (this.tableobj = f.response.OccuranceTable),
          this.mSystemAccessList = this.tableobj[0].MaintenaceAccess.length ? 
                SystemUtils.convertAccessListToSystem(this.tableobj[0].MaintenaceAccess[0]) : 
                SystemUtils.createEnvAccess(this.headerobj.description, this.headerobj.envName),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.endTime = new Date(m.NewEnd).getTime()),
              (m.startTime = new Date(m.NewStart).getTime())
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.seconds = (m.endTime - m.startTime) / 1000),
              (m.duration =
                Math.floor(m.seconds / 3600) +
                ":" +
                (Math.floor(m.seconds / 60) % 60))
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.startDateBefore = (m.NewStart)),
              (m.endDateBefore = (m.NewEnd)),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
       
              console.log("end 12", JSON.stringify(m.startDateBefore))
            ),
          ),
          console.log("table 1", this.tableobj),
          this.tableobj.filter((m: any) =>
          SchedulerUtils.updateMaintenanceObject(m)
        ),
          console.log("table final ---->>>>>", this.tableobj),
          (this.isLoadingIcon = false)
        )
      );
  }

  updateMaintenanceSeries(occid: any) {
    this.occID = occid;
    this.isLoadingIcon = true;
    var shour =
      this.timemanage.tptype === "AM" ? this.timemanage.tphours : parseInt(this.timemanage.tphours) + 12;

      var sds = new Date(this.startDate).toLocaleDateString("fr-CA");
      var sm = sds.split("/").reverse().join("-");
      // var sdt = [];
      // sdt.push(s);

      var dates = sm + ' ' + this.timemanage.tphours + ':' + this.timemanage.tpminutes + ':' + '00';
      //dates = this.convertToTimezone1(dates);
  
      var hour = new Date(dates).getHours().toString().padStart(2, "0");
      var minute = new Date(dates).getMinutes().toString().padStart(2, "0")
  
      var range = {
        startTime: {
          hours: hour.toString(),
          minutes: minute.toString(),
        },
        end: {
          endTime: {
            hours: "00",
            minutes: "00",
            totalDuration: "00",
          },
          duration: {
            hours: this.timemanage.estEditHoursSelection.toString(),
            minutes: this.timemanage.estEditMinuteSelection.toString(),
          },
          isEndTime: false,
        },
      };

    // var range = {
    //   startTime: {
    //     hours: shour.toString(),
    //     minutes: this.timemanage.tpminutes.toString(),
    //   },
    //   end: {
    //     endTime: {
    //       hours: "00",
    //       minutes: "00",
    //       totalDuration: "00",
    //     },
    //     duration: {
    //       hours: this.timemanage.estEditHoursSelection.toString(),
    //       minutes: this.timemanage.estEditMinuteSelection.toString(),
    //     },
    //     isEndTime: false,
    //   },
    // };

    var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    var s = sd.split("/").reverse().join("-");
    var sdt = [];
    sdt.push(s);
    console.log("dates--->" + JSON.stringify(sdt));


    this._restService
      .createMaintenanceSchedule(
        this.headerobj.activityLabel,
        this.environment,
        this.tableobj[0].MaintenaceAccess,
        this.headerobj.description,
        sdt,
        range,
        true,
        this.occID,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("1", f),
          console.log("3", this.occID),
          console.log("4", occid),
          //response.headerObj
          this.mtnRecurringRes.response.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.moccuranceid) === parseInt(this.occID)
                ? Object.assign(m, f.maintenanceRes.OccuranceTable[0])
                : ""
          ),
          console.log("1---",this.mtnRecurringRes.response.OccuranceTable ),
          console.log("2", this.mtnRecurringRes),

          this.mtnRecurringRes.response.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.moccuranceid) === parseInt(this.occID)
                ? (m.isEdited = true)
                : ""
          ),
          (this.tableobj = []),
          (this.headerobj = this.mtnRecurringRes.response.headerObj),
          (this.tableobj = this.mtnRecurringRes.response.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.endTime = new Date(m.NewEnd).getTime()),
              (m.startTime = new Date(m.NewStart).getTime())
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.seconds = (m.endTime - m.startTime) / 1000),
              (m.duration =
                Math.floor(m.seconds / 3600) +
                ":" +
                (Math.floor(m.seconds / 60) % 60))
            )
          ),

          f.maintenanceRes.OccuranceTable.filter((m:any) => (
            console.log("data...." ,(f.maintenanceRes.OccuranceTable[0])),
            m.sstartbefore = f.maintenanceRes.OccuranceTable[0].NewStart,
            m.sendbefore = f.maintenanceRes.OccuranceTable[0].NewEnd,
            m.sstart = this.timezoneConvert(f.maintenanceRes.OccuranceTable[0].NewStart),
            m.send = this.timezoneConvert(f.maintenanceRes.OccuranceTable[0].NewEnd),
            m.occid = this.occID,

           this.tableobj.filter(function (item) {
            console.log("m---", (item))

                  if(item.MoccuranceId === m.occid) {
                    
                  (item.startDateBefore = m.sstartbefore),
                  (item.endDateBefore = m.sendbefore),
                  (item.NewStart = m.sstart),
                  (item.NewEnd = m.send)
                  } 
                })            
          )
          ),
          // this.tableobj.filter(
          //   (m: any, index: any) => (
          //     (m.NewStart = m.NewStart),
          //     (m.NewEnd = m.NewEnd),
          //     (m.startDateBefore = this.convertToTimezone(m.NewStart)),
          //     (m.endDateBefore = this.convertToTimezone(m.NewEnd)),
          //     console.log("end 12", JSON.stringify(m.startDateBefore))
          //   ),
          // ),
          console.log("table 1", this.tableobj),
          console.log("table final ---->>>>>", this.tableobj),

          this.tableobj.filter((m: any) =>
          m.hasOwnProperty("MaintenaceAccess")
            ? m.MaintenaceAccess.filter((a: any) => (
              a.hasOwnProperty("Mlist")
              ? a.Mlist.filter((d:any) =>(
                d.start = this.timezoneConvert(d.startDate),
                d.end = this.timezoneConvert(d.endDate),
                d.startHour = new Date(d.start).getHours(),
                d.startMinutes = new Date(d.start).getMinutes(),
                d.endHours = new Date(d.end).getHours(),
                d.endMinutes = new Date(d.end).getMinutes(),
                d.position =
                parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70,
                d.length =
                parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70,
                console.log("int--->" + d.startDate + 'end-->' + d.endHours)
              ))
           :""
            )
            )
            : ""
        ),

          // this.tableobj.filter((m: any) =>
          //   m.hasOwnProperty("MaintenaceAccess")
          //     ? m.MaintenaceAccess.filter(
          //       (a: any) => (
          //         a.hasOwnProperty("Mlist")
          //           ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
          //           : "",
          //         a.hasOwnProperty("children")
          //           ? a.children.filter(
          //             (b: any) => (
          //               b.hasOwnProperty("Mlist")
          //                 ? b.Mlist.filter((dt: any) =>
          //                   this.addingHoursMinutes(dt)
          //                 )
          //                 : "",
          //               b.hasOwnProperty("children")
          //                 ? b.children.filter(
          //                   (c: any) => (
          //                     c.hasOwnProperty("Mlist")
          //                       ? c.Mlist.filter((dt: any) =>
          //                         this.addingHoursMinutes(dt)
          //                       )
          //                       : "",
          //                     c.hasOwnProperty("children")
          //                       ? c.children.filter(
          //                         (d: any) => (
          //                           d.hasOwnProperty("Mlist")
          //                             ? d.Mlist.filter((dt: any) =>
          //                               this.addingHoursMinutes(dt)
          //                             )
          //                             : "",
          //                           d.hasOwnProperty("children")
          //                             ? d.children.filter(
          //                               (f: any) => (
          //                                 f.hasOwnProperty("Mlist")
          //                                   ? f.Mlist.filter(
          //                                     (dt: any) =>
          //                                       this.addingHoursMinutes(
          //                                         dt
          //                                       )
          //                                   )
          //                                   : "",
          //                                 f.hasOwnProperty("children")
          //                                   ? f.children.filter(
          //                                     (g: any) => (
          //                                       g.hasOwnProperty(
          //                                         "Mlist"
          //                                       )
          //                                         ? g.Mlist.filter(
          //                                           (dt: any) =>
          //                                             this.addingHoursMinutes(
          //                                               dt
          //                                             )
          //                                         )
          //                                         : "",
          //                                       g.hasOwnProperty(
          //                                         "children"
          //                                       )
          //                                         ? g.children.filter(
          //                                           (h: any) => (
          //                                             h.hasOwnProperty(
          //                                               "Mlist"
          //                                             )
          //                                               ? h.Mlist.filter(
          //                                                 (
          //                                                   dt: any
          //                                                 ) =>
          //                                                   this.addingHoursMinutes(
          //                                                     dt
          //                                                   )
          //                                               )
          //                                               : "",
          //                                             h.hasOwnProperty(
          //                                               "children"
          //                                             )
          //                                               ? h.children.filter(
          //                                                 (
          //                                                   j: any
          //                                                 ) => (
          //                                                   j.hasOwnProperty(
          //                                                     "Mlist"
          //                                                   )
          //                                                     ? j.Mlist.filter(
          //                                                       (
          //                                                         dt: any
          //                                                       ) =>
          //                                                         this.addingHoursMinutes(
          //                                                           dt
          //                                                         )
          //                                                     )
          //                                                     : "",
          //                                                   j.hasOwnProperty(
          //                                                     "children"
          //                                                   )
          //                                                     ? j.children.filter(
          //                                                       (
          //                                                         k: any
          //                                                       ) => (
          //                                                         k.hasOwnProperty(
          //                                                           "Mlist"
          //                                                         )
          //                                                           ? k.Mlist.filter(
          //                                                             (
          //                                                               dt: any
          //                                                             ) =>
          //                                                               this.addingHoursMinutes(
          //                                                                 dt
          //                                                               )
          //                                                           )
          //                                                           : "",
          //                                                         k.hasOwnProperty(
          //                                                           "children"
          //                                                         )
          //                                                           ? k.children.filter(
          //                                                             (
          //                                                               l: any
          //                                                             ) => (
          //                                                               l.hasOwnProperty(
          //                                                                 "Mlist"
          //                                                               )
          //                                                                 ? l.Mlist.filter(
          //                                                                   (
          //                                                                     dt: any
          //                                                                   ) =>
          //                                                                     this.addingHoursMinutes(
          //                                                                       dt
          //                                                                     )
          //                                                                 )
          //                                                                 : "",
          //                                                               l.hasOwnProperty(
          //                                                                 "children"
          //                                                               )
          //                                                                 ? l.children.filter(
          //                                                                   (
          //                                                                     m: any
          //                                                                   ) =>
          //                                                                     m.hasOwnProperty(
          //                                                                       "Mlist"
          //                                                                     )
          //                                                                       ? m.Mlist.filter(
          //                                                                         (
          //                                                                           dt: any
          //                                                                         ) =>
          //                                                                           this.addingHoursMinutes(
          //                                                                             dt
          //                                                                           )
          //                                                                       )
          //                                                                       : ""
          //                                                                 )
          //                                                                 : ""
          //                                                             )
          //                                                           )
          //                                                           : ""
          //                                                       )
          //                                                     )
          //                                                     : ""
          //                                                 )
          //                                               )
          //                                               : ""
          //                                           )
          //                                         )
          //                                         : ""
          //                                     )
          //                                   )
          //                                   : ""
          //                               )
          //                             )
          //                             : ""
          //                         )
          //                       )
          //                       : ""
          //                   )
          //                 )
          //                 : ""
          //             )
          //           )
          //           : ""
          //       )
          //     )
          //     : ""
          // ),
          (this.isLoadingIcon = false)
        )
      );
  }

  mseriesSave() {
    this.tableobj.filter(
      (m: any, index: any) => (
        (m.NewStart = new Date(m.startDateBefore).toISOString()),
        (m.NewEnd = new Date(m.endDateBefore).toISOString()),
        console.log("end 12", JSON.stringify(m.startDateBefore))
      ),
    ),

    this.isLoadingIcon = true;
    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");

    this._restService
      .editRecMaintenance(
        this.environment,
        this.mseriesid,
        this.headerobj,
        this.tableobj,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Save Rec Mtn", f),
          this.maintenanceGroup.filter((mg: any) =>
            mg.hasOwnProperty("maintenanceList")
              ? mg.maintenanceList.filter((f: any) => (f.dropdown = false))
              : ""
          ),
          (this.isEditMtnSeriesShown = false),
          this.callbackgetTableView(startRange, endRange, this.masterEnvId),
          this.refreshScheduleTab(),
          (this.isSuccess = true),
          (this.successMessage = f.response),
          (this.isLoadingIcon = false)
        )
      );
  }

  //maintenanceRes
  ///////////////////////////////////// Edit end here

  loopingPagination(l: any) {
    this.minValue = 1;
    this.maxValue = l > 7 ? 7 : l;
    this.pageSize = l;
    this.prevValue = 0;
    //console.log("pageSize", this.pageSize);
  }

  nextpage(c: any, type: any) {
    let pageSize = this.pageSize;
    this.minValue = c + 1;
    this.maxValue = c + 7 >= pageSize ? pageSize : c + 7;
    this.prevValue = c;

    //console.log(this.minValue + "---" + this.maxValue + "---" + this.pageSize);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  prevpage(p: any, type: any) {
    this.minValue = p - 7 + 1;
    this.maxValue = p;
    this.prevValue = p - 7;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.prevValue);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  rangeStartDate() {
    this.isRangeEndShown = false;
    this.isRangeStartShown = !this.isRangeStartShown;
  }

  rangeEndDate() {
    this.isRangeStartShown = false;
    this.isRangeEndShown = !this.isRangeEndShown;
  }

  closeRangeStartDate() {
    this.isRangeStartShown = false;
  }

  closeRangeEndDate() {
    this.isRangeEndShown = false;
  }

  applyRangeStartDate() {
    var d = localStorage.getItem("startRange");
    this.rangestart = d.split("/").reverse().join("-");
    localStorage.setItem("startRange", d);
    this.isRangeStartShown = false;
  }

  applyRangeEndDate() {
    var d = localStorage.getItem("endRange");
    var ed = d.split("/").reverse().join("-");

    if (new Date(ed) > new Date(this.rangestart)) {
      this.rangeend = ed;
      localStorage.setItem("endRange", d);
      this.isRangeEndShown = false;
    } else {
      this.isFailure = true;
      this.failureMessage = "End date should be greater than start date";
    }
  }

  jobScheduleFilter(jobs: any) {
    var mlist: any = [];
    var machineNameArray: any = [];

    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map((s: any) => (j.BotAlias = s.BotAlias))
        : ""
    );

    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map(
          (s: any) => ((s.hover = false), (s.info = false), (j.mArray = []))
        )
        : ""
    );

    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map((s: any) =>
          s.MachineName !== "-" ? j.mArray.push(s.MachineName) : ""
        )
        : ""
    );

    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map((s: any) =>
          s.MachineName !== "-"
            ? (j.MachineFiltered = [...new Set(j.mArray)])
            : ""
        )
        : ""
    );

    console.log(
      "for timeline",
      this.getTimeLineData.TimeLineRes.JobScheduleRes
    );

    this.jobNameArray = [];
    var dt: any;
    for (var key in jobs) {
      //console.log("key", key);
      this.jobNameArray.push(key);
      this.getTimeLineData.TimeLineRes.JobScheduleRes[key].isExpand =
        key === "0" ? true : false;

      this.getTimeLineData.TimeLineRes.JobScheduleRes[key].hasOwnProperty(
        "MaintenanceSList"
      )
        ? this.getTimeLineData.TimeLineRes.JobScheduleRes[key].MaintenanceSList
          .length > 0 &&
          this.getTimeLineData.TimeLineRes.JobScheduleRes[key]
            .MaintenanceSList !== ""
          ? this.getTimeLineData.TimeLineRes.JobScheduleRes[
            key
          ].MaintenanceSList.filter(
            (m: any) => {
              (m.start = this.convertToTimeLineStart( new Date( this.timezoneConvert(m.MstartDate)) )),
              (m.end = this.convertToTimeLineEnd( new Date( this.timezoneConvert(m.MendDate)))),
              (m.StartHours = new Date(m.start).getHours()),
              (m.StartMinutes = new Date(m.start).getMinutes()),
              (m.EndHours = new Date(m.end).getHours()),
              (m.EndMinutes = new Date(m.end).getMinutes()),
              (m.position =
                m.StartHours * this.scaleWidth +
                this.scaleWidth / 2 +
                (m.StartMinutes / 60) * this.scaleWidth),
                m.endPos = m.EndHours * this.scaleWidth +
                this.scaleWidth / 2 +
                (m.EndMinutes / 60) * this.scaleWidth,
                m.length = m.endPos - m.position,
              (m.dropdown = false);

              return m.end > m.start;
            }
          )
          : ""
        : "";

      const currentJob = this.getTimeLineData.TimeLineRes.JobScheduleRes[key];

      this.getTimeLineData.TimeLineRes.JobScheduleRes[key].scheduleList.length >
        0 &&
        this.getTimeLineData.TimeLineRes.JobScheduleRes[key].scheduleList !== ""
        ? this.getTimeLineData.TimeLineRes.JobScheduleRes[
          key
        ].scheduleList.filter(
          (m: any) => {
            (dt = new Date(m.ScheduleStartDate)),
            (m.mmmstart = new Date(
              dt.getTime() - dt.getTimezoneOffset() * 60 * 1000
            )),
            (m.start = this.convertToTimeLineStart( new Date (this.timezoneConvert(m.ScheduleStartDate)))),
            (m.end = this.convertToTimeLineEnd( new Date ( this.timezoneConvert(m.ScheduleEndDate)) )),
            (m.StartHours = new Date(m.start).getHours()),
            (m.StartMinutes = new Date(m.start).getMinutes()),
            (m.EndHours = new Date(m.end).getHours()),
            (m.EndMinutes = new Date(m.end).getMinutes()),
            (m.position =
              m.StartHours * this.scaleWidth +
              this.scaleWidth / 2 +
              (m.StartMinutes / 60) * this.scaleWidth),
            m.endPos = m.EndHours * this.scaleWidth +
              this.scaleWidth / 2 +
              (m.EndMinutes / 60) * this.scaleWidth;
              m.length = m.endPos - m.position;
            (m.dropdown = false)

            return m.end > m.start;
          }
        )
        : "";

      if (currentJob.scheduleList){
        currentJob.scheduleList = currentJob.scheduleList.filter(m => m.end > m.start);
        currentJob.scheduleList.forEach(ms => {
          ms.status = 1;
          currentJob.MaintenanceSList.forEach(mg1 => { 
            if (this.hasConflict(ms, mg1)){
              ms.status = 2;
            }
          });

          this.allEvnArray.forEach(mg1 => {
            if (this.hasConflict(ms, mg1)){
              ms.status = 2;
            }
          });
        });
      }

      if (currentJob.MaintenanceSList){
        currentJob.MaintenanceSList = currentJob.MaintenanceSList.filter(m => m.end > m.start);
        currentJob.MaintenanceSList.forEach(m => m.status = 1);
      }
      

      this.getTimeLineData.TimeLineRes.JobScheduleRes[key].scheduleList.length >
        0 &&
        this.getTimeLineData.TimeLineRes.JobScheduleRes[key].scheduleList !== ""
        ? this.getTimeLineData.TimeLineRes.JobScheduleRes[
          key
        ].scheduleList.filter((m: any) =>
          m.MachineName !== "-" ? mlist.push(m.MachineName) : ""
        )
        : "";

      this.getTimeLineData.TimeLineRes.JobScheduleRes[key].scheduleList.length >
        0 &&
        this.getTimeLineData.TimeLineRes.JobScheduleRes[key].scheduleList !== ""
        ? this.getTimeLineData.TimeLineRes.JobScheduleRes[
          key
        ].scheduleList.filter((m: any) =>
          m.MachineName !== "-"
            ? (this.getTimeLineData.TimeLineRes.JobScheduleRes[key].machine =
              m.MachineName)
            : (this.getTimeLineData.TimeLineRes.JobScheduleRes[key].machine =
              "empty")
        )
        : "";
    }
    machineNameArray = [...new Set(mlist)];
    this.machineNameArray = machineNameArray;
    //console.log("m.MachineName", machineNameArray);
    this.JobScheduleRes = this.getTimeLineData.TimeLineRes.JobScheduleRes;
    //console.log("jobNameArray", this.jobNameArray);
  }

  environmentEvent(e: any) {
    this.isLoadingIcon = true;
    let v = e.target.value;
    //console.log("this.envList", this.envList);
    this.envList.filter((f: any) =>
      f.id === parseInt(v)
        ? ((this.environmentName = f.Environment_Name),
          (this.environment = f.id.toString()))
        : ""
    );

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(this.environment)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    var dt = new Date();
    var d = dt.getDate();
    var m = dt.getMonth() + 1;
    var y = dt.getFullYear();

    this.todayDate = y + "-" + m + "-" + d;

    
    this.callbackTimelineView(this.todayDate);
  }

  previousDate() {
    this.isLoadingIcon = true;
    var today = moment(this.todayDate).toDate();
    var yesterday = moment(today).toDate();
    yesterday.setDate(yesterday.getDate() - 1);
    this.todayDate = yesterday.toString();

    var p = moment(this.todayDate).toDate();
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var pre = y + "-" + m + "-" + d;

    this.tday = pre;

    this.callbackTimelineView(pre);
  }

  nextDate() {
    this.isLoadingIcon = true;
    var today = moment(this.todayDate).toDate();
    var next = moment(today).toDate();
    next.setDate(next.getDate() + 1);
    this.todayDate = next.toString();

    var p = moment(this.todayDate).toDate();
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var nxt = y + "-" + m + "-" + d;

    this.tday = nxt;

    this.callbackTimelineView(nxt);
  }

  expandRow(e: any) {
    this.JobScheduleRes.filter((f: any) =>
      f.BotId === e ? (f.isExpand = !f.isExpand) : (f.isExpand = false)
    );
  }

  searchKeyword(e: any) {
    if (e.target.value === "") {
      (this.filterArray = []),
        (this.actualArray = []),
        (this.actualArray = this.getTableView),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.actualArray.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
    } else {
      let v = e.target.value.toLowerCase();

      this.searchArray = [];
      this.filterArray = [];

      this.actualArray = this.getTableView;

      this.actualArray.map((f: any) =>
        f.start.toLowerCase().includes(v) ||
          f.end.toLowerCase().includes(v) ||
          f.BotName.toLowerCase().includes(v) ||
          f.BotPath.toLowerCase().includes(v) ||
          f.type.toLowerCase().includes(v) ||
          f.Status.toLowerCase().includes(v) ||
          f.activity.toLowerCase().includes(v) ||
          f.series.toLowerCase().includes(v)
          ? this.searchArray.push(f)
          : ""
      ),
        (this.actualArray = []),
        (this.actualArray = this.searchArray),
        (this.totalJobsCount = parseFloat(this.actualArray.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.actualArray.length),
        this.searchArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
      //this.filterArray = this.searchArray;
    }
  }

  startTimeEvent() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isStartName === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.StartDate.localeCompare(b.StartDate);
      });
      this.isStartName = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.StartDate.localeCompare(a.StartDate);
      });
      this.isStartName = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
    }
  }

  endTimeEvent() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isEndName === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.EndDate.localeCompare(b.EndDate);
      });
      this.isEndName = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.EndDate.localeCompare(a.EndDate);
      });
      this.isEndName = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
    }
  }

  applyDates() {
    this.isLoadingIcon = true;

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this._restService
      .getTableView(this.environment, startRange, endRange, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          //console.log("getTableView", f),
          (this.flagCount = 0),
          (this.actualArray = []),
          (this.getTableView = []),
          (this.filterArray = []),
          ((this.getTableView = f.TableRes.tableData),
            (this.actualArray = f.TableRes.tableData),
            (this.totalJobsCount = parseFloat(this.getTableView.length) / 7),
            (this.paginationLength =
              this.totalJobsCount % 1 === 0
                ? Math.round(this.totalJobsCount)
                : Math.round(this.totalJobsCount) + 1),
            this.loopingPagination(this.getTableView.length),
            this.actualArray.map(
              (f: any) => (
                (f.occurrences =
                  f.RecuringTotal === undefined
                    ? f.SScheduleCount + 0
                    : f.SScheduleCount + f.RecuringTotal),
                f.isFlagged !== undefined
                  ? f.isSchedule && f.isFlagged === 1
                    ? (this.flagCount = this.flagCount + 1)
                    : ""
                  : "",
                (f.StartDate = this.timezoneConvert(f.StartDate)),
                (f.EndDate = this.timezoneConvert(f.EndDate)),
                (f.start = new Date(f.StartDate).toString()),
                (f.end = new Date(f.EndDate).toString()),
                (f.StartFormatted = new Date(f.StartDate).toLocaleString()),
                (f.EndFormatted = new Date(f.EndDate).toLocaleString()),
                (f.type = f.isSchedule
                  ? "Job"
                  : f.isMaintenance
                    ? "Maintenance"
                    : ""),
                (f.Status =
                  f.isSchedule && f.isFlagged === 1
                    ? "Flagged"
                    : f.Sstatus === 2
                      ? "Conflict"
                      : f.Sstatus === 1 && f.deployed === 0
                        ? "Scheduled"
                        : f.Sstatus === 1 && f.deployed === 1
                          ? "Completed"
                          : f.Sstatus === 1 && f.deployed === 2
                            ? "Deployment failed"
                            : ""),
                (f.activity = (
                  f.isMaintenance ? f.moccuranceId : f.occuranceId
                ).toString()),
                (f.series = (
                  f.isSchedule
                    ? f.seriesId !== null
                      ? "SR" + f.seriesId
                      : ""
                    : f.isMaintenance
                      ? f.maintenanceSeriesId !== null
                        ? "M" + f.maintenanceSeriesId
                        : ""
                      : ""
                ).toString())
              )
            ),
            this.actualArray.map((f: any, index: any) =>
              index + 1 <= 7 ? this.filterArray.push(f) : ""
            ),
            console.log("Maari Yes --->", this.actualArray)),
          (this.isLoadingIcon = false)
        )
      );
  }

  deleteOccurrence(obj: any, type: any) {
    console.log("mid-->" + JSON.stringify(obj));



    if ((new Date(obj.StartDate) >= new Date() )|| (new Date(obj.ScheduleStartDate) >= new Date())) {
      // this.rowID = rid;
      // this.stype = type;
      // this.sysId = sysId;
      // this.delOccBid = bid;
      // this.delOccMid = mid;
      this.stype = type;
      this.sysId = obj.systemId;
      this.delOccBid = obj.botId || obj.BotId;
      this.delOccMid = obj.moccuranceId || obj.MoccuranceId;
      this.occID = obj.occuranceId;
      this.rowID = obj.machineId || obj.MachineId;
      this.isConfirmDeleteOcc = true;
    } else {
      this.isInfoModelShown = true;
      this.infoMessage = "You can't delete the past occurrence";
    }
    console.log("delete job --->" + this.stype + this.sysId + this.delOccBid + this.occID + this.rowID);

  }

  cancelInfoMessage() {
    this.isInfoModelShown = false;
    this.infoMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.infoMessage = ""),
        this.router.navigate([""]))
      : (this.infoMessage = "");
    this.maintenanceGroup.filter((mg: any) =>
      mg.hasOwnProperty("maintenanceList")
        ? mg.maintenanceList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("MaintenanceSList")
        ? mg2.MaintenanceSList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );
  }

  ConfirmCancelOccEvent() {
    this.isConfirmDeleteOcc = false;
  }

  ConfirmDeleteOccEvent() {
    this.isConfirmDeleteOcc = false;
    this.isLoading = true;

    console.log("delete --->" + this.stype + this.rowID + this.delOccMid + this.masterEnvId);


    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    if (this.stype === "Job") {
      this._restService
        .delOccurance(
          this.environment,
          this.occID,
          this.delOccBid,
          this.rowID,
          this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (console.log("error")),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (console.log("no error")),
            this.callbackgetTableView(startRange, endRange, this.masterEnvId),
            this.refreshScheduleTab(),
            (this.isSuccess = true),
            (this.successMessage = f.response),
            (this.isLoading = false)
          )
        )
    } else if (this.stype === "Maintenance") {
      this._restService
        .delMaintenanceOccurance(
          this.environment,
          this.sysId,
          this.delOccMid,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            this.callbackgetTableView(startRange, endRange, this.masterEnvId),
            this.refreshScheduleTab(),
            (this.isSuccess = true),
            (this.successMessage = f.StatusInfo),
            (this.isLoading = false)
          )
        )
    }

    // this.stype === "job"
    //   ? this._restService
    //       .delOccurance(
    //         this.environment,
    //         this.rowID,
    //         this.delOccBid,
    //         this.delOccMid,
    //         this.masterEnvId
    //       )
    //       .pipe(
    //         catchError((e) => {
    //           (this.isLoading = false),
    //             (this.isFailure = true),
    //             (this.failureMessage = e.error.StatusInfo);
    //           return e;
    //         })
    //       )
    //       .subscribe(
    //         (f: any) => (
    //           this.callbackgetTableView(startRange, endRange, this.masterEnvId),
    //           this.callbackTimelineView(),
    //           this.refreshScheduleTab(),
    //           (this.isSuccess = true),
    //           (this.successMessage = f.response),
    //           (this.isLoading = false)
    //         )
    //       )
    //   : this.stype === "maintenance"
    //   ? this._restService
    //       .delMaintenanceOccurance(
    //         this.environment,
    //         this.sysId,
    //         this.rowID,
    //         this.masterEnvId
    //       )
    //       .pipe(
    //         catchError((e) => {
    //           (this.isLoading = false),
    //             (this.isFailure = true),
    //             (this.failureMessage = e.error.StatusInfo);
    //           return e;
    //         })
    //       )
    //       .subscribe(
    //         (f: any) => (
    //           this.callbackgetTableView(startRange, endRange, this.masterEnvId),
    //           this.callbackTimelineView(),
    //           this.refreshScheduleTab(),
    //           (this.isSuccess = true),
    //           (this.successMessage = f.StatusInfo),
    //           (this.isLoading = false)
    //         )
    //       )
    //   : "";
  }

  deleteSeries(obj, type) {
    console.log("delete series-->" + JSON.stringify(obj));


    if ((new Date(obj.StartDate) >= new Date()) || (new Date(obj.seriesStartDate) >= new Date())) {
      this.isConfirmDeleteSeries = true;
      this.SID = obj.seriesId || obj.maintenanceSeriesId;
      this.Mtype = type;
      this.MsysId = obj.systemId;
      this.delOccBid = obj.botId || obj.BotId;
      this.delOccMid = obj.moccuranceId || obj.MoccuranceId;
      this.rowID = obj.machineId || obj.MachineId
    } else {
      this.isInfoModelShown = true;
      this.infoMessage = "You can't delete the past series";
    }
  }

  ConfirmDeleteSeriesEvent() {
    this.isConfirmDeleteSeries = false;
    this.isLoading = true;

    console.log("delete event-->" + this.SID + this.delOccBid + this.delOccMid + this.masterEnvId);


    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this.Mtype === "Job"
      ? this._restService
        .delSeries(
          this.environment,
          this.SID,
          this.delOccBid,
          this.rowID,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            this.callbackgetTableView(startRange, endRange, this.masterEnvId),
            this.refreshScheduleTab(),
            (this.isSuccess = true),
            (this.successMessage = f.response),
            (this.isLoading = false)
          )
        )
      : this.Mtype === "Maintenance"
        ? this._restService
          .delMaintenanceSeries(
            this.environment,
            this.MsysId,
            this.SID,
            this.masterEnvId
          )
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              this.callbackgetTableView(startRange, endRange, this.masterEnvId),
              this.refreshScheduleTab(),
              (this.isSuccess = true),
              (this.successMessage = f.response),
              (this.isLoading = false)
            )
          )
        : "";
  }

  maintenanceListEvent(mid: any) {
    this.allEvnArray.filter((mg: any) =>
      mg.mtn.MoccuranceId === mid ? (mg.mtn.dropdown = true) : (mg.mtn.dropdown = false)
    );

    this.maintenanceGroup.filter((mg: any) =>
      mg.hasOwnProperty("maintenanceList")
        ? mg.maintenanceList.filter((f: any) =>
          f.MoccuranceId === mid ? (f.dropdown = true) : (f.dropdown = false)
        )
        : ""
    );


    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("MaintenanceSList")
        ? mg2.MaintenanceSList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );
  }

  machineListEvent(oid: any) {
    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) =>
          f.occuranceId === oid ? (f.dropdown = true) : (f.dropdown = false)
        )
        : ""
    );

    this.maintenanceGroup.filter((mg: any) =>
      mg.hasOwnProperty("maintenanceList")
        ? mg.maintenanceList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("MaintenanceSList")
        ? mg2.MaintenanceSList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );
  }

  mouseoverMachine(id: any) {
    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) =>
          f.occuranceId === id ? (f.hover = true) : (f.hover = false)
        )
        : ""
    );
  }

  mouseoutMachine(id: any) {
    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter(
          (f: any) => ((f.hover = false), (f.info = false))
        )
        : ""
    );
  }

  mouseoverMachineInfo(id: any) {
    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) =>
          f.occuranceId === id
            ? ((f.hover = false), (f.info = true))
            : ((f.hover = false), (f.info = false))
        )
        : ""
    );
  }

  mouseoverjobSeries(id: any) {
    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map((f: any) =>
          f.occuranceId === id
            ? ((f.hover = true), (f.info = false))
            : ((f.hover = false), (f.info = false))
        )
        : ""
    );
  }

  mouseoverjobInfo(id: any) {
    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map((f: any) =>
          f.occuranceId === id
            ? ((f.hover = false), (f.info = true))
            : ((f.hover = false), (f.info = false))
        )
        : ""
    );
  }

  mouseoutjobSeries(id: any) {
    this.getTimeLineData.TimeLineRes.JobScheduleRes.map((j: any, i: any) =>
      j.hasOwnProperty("scheduleList")
        ? j.scheduleList.map((f: any) => ((f.hover = false), (f.info = false)))
        : ""
    );
  }

  jobMtnListEvent(jid: any) {
    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("MaintenanceSList")
        ? mg2.MaintenanceSList.filter((f: any) =>
          f.MoccuranceId === jid ? (f.dropdown = true) : (f.dropdown = false)
        )
        : ""
    );

    this.maintenanceGroup.filter((mg: any) =>
      mg.hasOwnProperty("maintenanceList")
        ? mg.maintenanceList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );
  }

  jobMachineListEvent(jid: any, dt: any) {
    this.scheduleListObj = dt;
    this.scheduleListOccId = jid;
    console.log("scheduleListObj", this.scheduleListObj);
    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) =>
          f.occuranceId === jid ? (f.dropdown = true) : (f.dropdown = false)
        )
        : ""
    );

    this.maintenanceGroup.filter((mg: any) =>
      mg.hasOwnProperty("maintenanceList")
        ? mg.maintenanceList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.machineGroup.filter((mg2: any) =>
      mg2.hasOwnProperty("scheduleList")
        ? mg2.scheduleList.filter((f: any) => (f.dropdown = false))
        : ""
    );

    this.JobScheduleRes.filter((mg2: any) =>
      mg2.hasOwnProperty("MaintenanceSList")
        ? mg2.MaintenanceSList.filter((f: any) => (f.dropdown = false))
        : ""
    );
  }

  callbackComponent(t: string) {
    t === "calendar"
      ? ((this.isCalendarSelected = true),
        (this.isTimelineSelected = false),
        (this.isTableSelected = false))
      : t === "timeline"
        ? ((this.isCalendarSelected = false),
          (this.isTimelineSelected = true),
          (this.isTableSelected = false))
        : t === "table"
          ? ((this.isCalendarSelected = false),
            (this.isTimelineSelected = false),
            (this.isTableSelected = true))
          : "";

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");
    this.refreshScheduleTab();
    this.callbackgetTableView(startRange, endRange, this.masterEnvId);
  }

  clearAll() {
    localStorage.setItem("isFilter", "false");
    localStorage.setItem("mids", JSON.stringify([]));
    localStorage.setItem("bids", JSON.stringify([]));
    localStorage.setItem("sids", JSON.stringify([]));

    this.isfilterEnabled = false;
    this.isLoadingIcon = true;
    this.lsValue = false;
    this.limitselection = "2";
    this.autoselectmaintenance = "2";
    this.filtertype = "1";
    var uniqueMachine: any = [];
    var uniqueJob: any = [];
    this.machinesSelectedArray = [];
    this.searchMachinefilter = [];
    this.jobsSelectedArray = [];
    this.machinesFilterArray = [];
    this.jobsFilterArray = [];
    this.searchjobfilterRes = [];

    this.searchMachineInput = "";
    this.searchJobsInput = "";
    this.searchMaintenanceInput = "";

    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this._restService
      .getLeftPanelData(
        this.environment,
        this.filtertype,
        this.limitselection,
        this.autoselectmaintenance,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.MtnfilterArray = []),
          (this.searchMaintenance = []),
          (this.machinejobArray = []),
          (this.MtnfilterArray = f.FilterRes.level2List),
          this.MtnfilterArray.map((f: any) => (f.checked = false)),
          (this.searchMaintenance = this.MtnfilterArray),
          (this.machinejobArray = f.FilterRes.leftPanelMachineBotRes),
          this.machinejobArray.map(
            (f: any) => ((f.mchecked = false), (f.bchecked = false))
          ),
          (uniqueMachine = this.machinejobArray.reduce((u: any, o: any) => {
            if (!u.some((obj: any) => obj.machineId === o.machineId)) {
              u.push(o);
            }
            return u;
          }, [])),
          uniqueMachine.map((m: any) =>
            m.machineId !== null && m.botId !== null
              ? this.machinesFilterArray.push(m)
              : ""
          ),
          (uniqueJob = this.machinejobArray.reduce((u: any, o: any) => {
            if (!u.some((obj: any) => obj.botId === o.botId)) {
              u.push(o);
            }
            return u;
          }, [])),
          uniqueJob.map((m: any) =>
            m.machineId !== null && m.botId !== null
              ? this.jobsFilterArray.push(m)
              : ""
          ),
          this.refreshScheduleTab(),
          this.callbackgetTableView(startRange, endRange, this.masterEnvId),
          (this.machinesSearchArray = this.machinesFilterArray),
          (this.jobsSearchArray = this.jobsFilterArray),
          (this.searchjobfilterRes = this.jobsFilterArray),
          console.log("Machine---->", this.machinesFilterArray),
          console.log("Jobs---->", this.jobsFilterArray),
          (this.isLoadingIcon = false)
        )
      );
  }

  checkTimezone() {
    var dt = new Date();
    var offset = dt.getTimezoneOffset();
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    if (Math.abs(offset) !== Math.abs(timezone)) {
      this.timezoneInfo = true;
      this.isDifferentTimezone = true;
    } else {
      this.isDifferentTimezone = false;
      this.timezoneInfo = false;
    }
  }

  ConfirmCancelSeriesEvent() {
    this.isConfirmDeleteSeries = false;
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  convertToTimeLineStart(dt: Date){
    const timeZoneFromDB:any = localStorage.getItem('timezoneName');
    const startTime = moment(this.todayDate).startOf('day').toDate();

    return dt < startTime ? startTime : dt;
  }

  convertToTimeLineEnd(dt: Date){
    const timeZoneFromDB:any = localStorage.getItem('timezoneName');
    const endTime = moment(this.todayDate).endOf('day').toDate();

    return dt > endTime ? endTime : dt;
  }

  convertToTimezone(d: any) {

    var dt = new Date(d);

    var offset = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() - offset);

    var timezone: any = parseInt(localStorage.getItem("localOffset"));
    var local: any = parseInt(localStorage.getItem("timezone"));

    console.log("timezone", offset, timezone);

    if (Math.abs(offset) === Math.abs(timezone)) {
      let mz = (new Date(dt.setMinutes(dt.getMinutes() - local)));
      console.log("trueeeeeeee" + mz);
      return (
        
          mz.getFullYear().toString().padStart(4, "0") +
          "-" +
          (mz.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          mz.getDate().toString().padStart(2, "0") +
          " " +
          mz.getHours().toString().padStart(2, "0") +
          ":" +
          mz.getMinutes().toString().padStart(2, "0") +
          ":" +
          mz.getSeconds().toString().padStart(2, "0")
        
      
      );
    } else {
      console.log("falseeeeeee");
      return d;
    }
  }

  timezoneConvert(dt) {
    const d = new Date(dt);
    var timeZoneFromDB: any = localStorage.getItem('timezoneName');
    let timezone = moment.tz(d, timeZoneFromDB).format("YYYY-MM-DD HH:mm:ss");
    return timezone;

  }

  inverseTimezoneConvert(dt){
    var timeZoneFromDB: any = localStorage.getItem('timezoneName');
    const d =  moment.tz(dt, timeZoneFromDB);
    let timezone = d.local().format("YYYY-MM-DD HH:mm:ss");
    return timezone;
  }

   convertToTimezone1(d: any) {
    var dt = new Date(d);
    var offset = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() - offset);

    var timezone: any = parseInt(localStorage.getItem("localOffset"));
    var local: any = parseInt(localStorage.getItem("timezone"));

    console.log("timezone", offset, timezone);

    if (Math.abs(offset) === Math.abs(timezone)) {
      let mz = (new Date(dt.setMinutes(dt.getMinutes() - local)));
      console.log("trueeeeeeee" + mz);
      return (
        [
          mz.getFullYear().toString().padStart(4, "0") +
          "-" +
          (mz.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          mz.getDate().toString().padStart(2, "0") +
          " " +
          mz.getHours().toString().padStart(2, "0") +
          ":" +
          mz.getMinutes().toString().padStart(2, "0") +
          ":" +
          mz.getSeconds().toString().padStart(2, "0")
        ]
       
      );
    } else {
      console.log("falseeeeeee");
      return d;
    }
  }

  @HostListener('window:resize', ['$event'])
  resize(event) {
      this.timelineToggle = !this.timelineToggle;
  }

  onSave(){
    var startRange = localStorage
      .getItem("startRange")
      .split("/")
      .reverse()
      .join("-");
    var endRange = localStorage
      .getItem("endRange")
      .split("/")
      .reverse()
      .join("-");

    this.closeJobModelShown();
    this.callbackgetTableView(startRange, endRange, this.masterEnvId);
    this.refreshScheduleTab(); 
  }
}
